import React, { Component } from 'react';
import ReactDOM from 'react-dom';

//import axios from 'axios';
import FakeData from '.././fake-data';
import { Link } from 'react-router-dom';
import VideoStreamTV, { VideoPlayer } from "../components/VideoStreamTV";

import { FilterView, SetTournGameModal, ItemPicker, Modal, ComboBox, PhotoAddModal, TagView, MomentPickerModal, EditGameModal, PlayOffView } from './Common';

import SoccerPitch from './SoccerPitch';
import LineupLimit, {availableSports} from './SportLineLimit';
//axios.defaults.baseURL = FakeData.URL;
//axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
function copyStyles(sourceDoc, targetDoc) {
  console.log(sourceDoc.styleSheets)
  Array.from(sourceDoc.styleSheets).forEach(styleSheet => {
    try {
      if (styleSheet.cssRules) { // for <style> elements
        const newStyleEl = sourceDoc.createElement('style');
  
        try {
          Array.from(styleSheet.cssRules).forEach(cssRule => {
            // write the text of each rule into the body of the style element
            newStyleEl.appendChild(sourceDoc.createTextNode(cssRule.cssText));
          });
        } catch (error) {
          
        }
  
        targetDoc.head.appendChild(newStyleEl);
      } else if (styleSheet.href) { // for <link> elements loading CSS from a URL
        const newLinkEl = sourceDoc.createElement('link');
  
        newLinkEl.rel = 'stylesheet';
        newLinkEl.href = styleSheet.href;
        targetDoc.head.appendChild(newLinkEl);
      }
    } catch (error) {
      
    }
  });
}

export class GameTeamsForm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="add-game-teams">
        <GameTeamInput user={this.props.user} team={this.props.game.teamTwo?this.props.game.teamTwo:false} disabled={Boolean(this.props.game.teamOne)} pickerData={this.props.pickerData} value={(this.props.game.teamOne) ? this.props.game.teamOne.name : ''} error={this.props.errors.teamOneError} setTeam={this.props.onTeamOneSelected} data={this.props.data} />
        <GapInput text="vs" />
        <GameTeamInput user={this.props.user} team={this.props.game.teamOne?this.props.game.teamOne:false} disabled={Boolean(this.props.game.teamTwo)} pickerData={this.props.pickerData} value={(this.props.game.teamTwo) ? this.props.game.teamTwo.name : ''} error={this.props.errors.teamTwoError} setTeam={this.props.onTeamTwoSelected} data={this.props.data} />
      </div>
    );
  }
}

export class GameTeamInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isFocus: false,
      value: (this.props.value) ? this.props.value : "",
      teams: this.props.data,
      filteredData: this.props.data,
      isModalOpen: false,
      userTo: null,
      userError: false,
      emailTo: "",
      emailError: false,
      teamName: "",
      teamError: false
    }

    this.handleKeyup = this.handleKeyup.bind(this)
    this.handleBlur = this.handleBlur.bind(this)
    this.selectTeam = this.selectTeam.bind(this)
    this.addTeam = this.addTeam.bind(this)
    this.setUserToInvite = this.setUserToInvite.bind(this)
    this.emailChange = this.emailChange.bind(this)
    this.nameChange = this.nameChange.bind(this)
  }

  handleKeyup(e) {
    var bool = (e.target.value == "") ? false : true
    const val = e.target.value
    const newTeams = []
    this.state.teams.forEach((team) => {
      if (team.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
        newTeams.push(team)
      }
    })

    this.setState({
      isFocus: bool,
      value: val,
      filteredData: newTeams
    })
  }

  handleBlur(e) {
    this.setState({
      isFocus: false
    })
  }

  selectTeam(team) {
    if (team.id) {
      this.setState({
        isFocus: false,
        value: team.name
      })

      this.props.setTeam(team)
    }
  }

  setUserToInvite(user) {
    this.setState({
      userTo: user,
      userError: false
    });
  }

  emailChange(e) {
    const val = e.target.value
    if ((val.indexOf("@") <= -1) || (val.indexOf(".") <= -1)) {
      this.setState({
        emailError: true,
        emailTo: val
      });
    } else {
      this.setState({
        emailError: false,
        emailTo: val
      });
    }
  }

  nameChange(e) {
    this.setState({
      teamName: e.target.value,
      teamError: false
    });
  }

  addTeam() {
    if ((this.state.teamName == "") || (this.state.teamName == null)) {
      this.setState({
        teamError: true
      });

      return
    }

    if ((this.state.emailTo == "") || (this.state.emailTo == null)) {
      this.setState({
        emailError: true
      });

      return
    }

    if (this.state.userTo == null) {
      this.setState({
        userError: true
      });

      return
    }

    const dataTo = {
      user: this.props.user,
      userTo: this.state.userTo,
      teamName: this.state.teamName,
      emailTo: this.state.emailTo
    }

    const _that = this

    FakeData.post('/registerGhostTeam.php?auth0', dataTo, {
      success: ((data) => {
        _that.selectTeam(data)
        _that.setState({
          isModalOpen: false
        });
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    const items = this.state.filteredData.filter((item, i)=>{
      if(this.props.team){
        return item.id !== this.props.team.id && item.age === this.props.team.age;
      } else{
        return true;
      }
    })
    return (
      <div className="add-game-team">
        <div className="text-field" style={{ width: "100%" }}>
          <span>Enter Team Name</span>
          <div className="input-for" onMouseLeave={this.handleBlur}>
            <input value={this.state.value} disabled={this.props.disabled} className={(this.props.error) ? 'error' : ''} onChange={(e) => this.handleKeyup(e)} />
            {this.state.isFocus &&
              <div className="list">
                {items.map((i, x) =>
                  <div key={x} onClick={() => this.selectTeam(i)} className="item"><img src={i.image} /><span>{i.name}</span></div>
                )}
              </div>
            }
            {((items.length == 0) && (this.state.isFocus)) &&
              <div className="no-results">
                <span>No Results</span>
                <a href={FakeData.baseURL+"/create/team"}>Add Team</a>
              </div>
            }
          </div>
        </div>
        <button disabled={this.props.disabled} onClick={() => {
          window.location = FakeData.baseURL+"/create/team";
        }}>Or Add Team</button>
        <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({
          isModalOpen: false
        })}>
          <div className="add-a-team">
            <h1>Add A Team</h1>
            <div className="input-field">
              <span>Team Name</span>
              <input value={this.state.teamName} onChange={this.nameChange} className={(this.state.teamError) ? 'error' : ''} />
            </div>
            <div className="input-field">
              <ItemPicker user={this.props.user} error={this.state.userError} onSelectedItem={this.setUserToInvite} width="27.85em" label="Name" data={this.props.pickerData} />
            </div>
            <div className="input-field">
              <span>Validation Email</span>
              <input value={this.state.emailTo} onChange={this.emailChange} className={(this.state.emailError) ? 'error' : ''} />
            </div>
            <button onClick={this.addTeam}>Add</button>
          </div>
        </Modal>
      </div>
    );
  }
}

export class GapInput extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={'gap-input ' + this.props.color}>
        {this.props.text}
      </div>
    );
  }
}

export class GameVenueForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      types: ["Friendly", "Group Stages", "League", "Quarter Finals", "Semi Finals", "Finals"]
    }
  }

  render() {
    return (
      <div className="add-game-venue">
        <GameMatchTypeField user={this.props.user} label="Match Type" value={(this.props.game.matchType) ? this.props.game.matchType : ''} error={this.props.errors.typeError} onSetType={this.props.onSetType} placeholder="Select Match Type" data={this.state.types} />
        <GapInput text="at" color="blank" />
        <GamePlaceField user={this.props.user} places={this.props.places} value={(this.props.game.matchPlace) ? this.props.game.matchPlace : ''} error={this.props.errors.matchError} onSetPlace={this.props.onSetPlace} />
      </div>
    );
  }
}

export class GameVenueTimeForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      types: ["Friendly", "Group Stages", "League", "Quarter Finals", "Semi Finals", "Finals"]
    }
  }

  render() {
    return (
      <div className="add-game-venue">
        <GameDummyInput user={this.props.user} value={(this.props.game.matchHalf) ? this.props.game.matchHalf : ''} error={this.props.errors.halfTimeError} label="Set Half Time" type="number" onValueChange={this.props.onSetHalf} />
        <GapInput text="at" color="blank" />
        <GamePlaceField user={this.props.user} places={this.props.places} value={(this.props.game.matchPlace) ? this.props.game.matchPlace : ''} error={this.props.errors.matchError} onSetPlace={this.props.onSetPlace} />
      </div>
    );
  }
}

export class GameMatchTypeField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSelecting: false,
      selectedItem: (this.props.value == '') ? this.props.placeholder : this.props.value
    }

    this.selectItem = this.selectItem.bind(this)
  }

  selectItem(item) {
    this.setState({
      selectedItem: item,
      isSelecting: false
    });

    this.props.onSetType(item)
  }

  render() {
    const items = this.props.data
    return (
      <div className="add-game-match-type">
        <span>{this.props.label}</span>
        <div className={(this.props.error) ? 'combo-box error' : 'combo-box'}>
          <div className="box-field" onClick={() => this.setState({
            isSelecting: (this.state.isSelecting) ? false : true
          })}>
            <span>{this.state.selectedItem}</span>
            <span></span>
          </div>
          {this.state.isSelecting &&
            <div className="box-options" onMouseLeave={() => this.setState({
              isSelecting: false
            })}>
              {items.map((item, i) =>
                <div className="box-option" onClick={() => this.selectItem(item)} key={i}>{item}</div>
              )}
            </div>
          }
        </div>
      </div>
    );
  }
}

export class GamePlaceField extends React.Component {
  constructor(props) {
    super(props)
    this.setPlace = this.setPlace.bind(this)
    this.state = {
      value: this.props.value,
      isModalOpen: false,
      lon: "",
      lat: "",
      name: "",
      address: ""
    }

    this.addPlace = this.addPlace.bind(this)
    this.setValue = this.setValue.bind(this)
  }

  setPlace(e) {
    var val = (e.name) ? e.name : e
    this.props.onSetPlace(val)
    this.setState({
      value: val,
      isModalOpen: false
    });
  }

  setValue(key, e) {
    switch (key) {
      case "name":
        this.setState({
          name: e.target.value,
          nameError: false
        });
        break;
      case "address":
        this.setState({
          address: e.target.value,
          addressError: false
        });
        break;
      case "lon":
        this.setState({
          lon: e.target.value,
          lonError: false
        });
        break;
      case "lat":
        this.setState({
          lat: e.target.value,
          latError: false
        });
        break;
      default:

    }
  }

  addPlace() {
    const _that = this
    if ((this.state.name == "") || (this.state.name == null)) {
      this.setState({
        nameError: true
      });

      return
    }

    if ((this.state.address == "") || (this.state.address == null)) {
      this.setState({
        addressError: true
      });

      return
    }

    if ((this.state.lon == "") || (this.state.lon == null)) {
      this.setState({
        lonError: true
      });

      return
    }

    if ((this.state.lat == "") || (this.state.lat == null)) {
      this.setState({
        latError: true
      });

      return
    }

    const dataTo = {
      user: this.props.user,
      lon: this.state.lon,
      address: this.state.address,
      lat: this.state.lat,
      name: this.state.name
    }

    FakeData.post('/createPlace.php?auth0', dataTo, {
      success: ((data) => {
        _that.setPlace(data)
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    return (
      <div className="add-game-place">
        <span>Play Ground</span>
        <input value={this.state.value} onChange={() => {

        }} onFocus={() => this.setState({
          isModalOpen: true
        })} className={(this.props.error) ? 'error' : ''} />
        <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({
          isModalOpen: false
        })}>
          <div className="add-place">
            <h1>Add Place</h1>
            <ComboBox user={this.props.user} label="Location" width="27.85em" onSelectedItem={this.setPlace} placeholder={(this.state.value != '') ? this.state.value : "Select a location"} data={this.props.places} />
            <br />
            <span style={{ display: "block", textAlign: "center", fontSize: "10px", color: "#888" }}>OR</span>
            <br />
            <div className="input-field">
              <span>City</span>
              <input className={(this.state.nameError) ? 'error' : ''} onChange={(e) => this.setValue('name', e)} value={this.state.name} />
            </div>
            <div className="input-field">
              <span>Address</span>
              <input className={(this.state.addressError) ? 'error' : ''} onChange={(e) => this.setValue('address', e)} value={this.state.address} />
            </div>

            <div className="split-input">
              <div className="input-field">
                <span>Longitude</span>
                <input type="number" className={(this.state.lonError) ? 'error' : ''} onChange={(e) => this.setValue('lon', e)} value={this.state.lon} />
              </div>
              <div className="input-field">
                <span>Latitude</span>
                <input type="number" className={(this.state.latError) ? 'error' : ''} onChange={(e) => this.setValue('lat', e)} value={this.state.lat} />
              </div>
            </div>
            <button onClick={this.addPlace}>Add Place</button>
          </div>
        </Modal>
      </div>
    );
  }
}

export class GameDurationForm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="add-game-duration">
        <GameDummyInput user={this.props.user} value={(this.props.game.matchHalf) ? this.props.game.matchHalf : ''} error={this.props.errors.halfTimeError} label="Set Half Time" type="number" onValueChange={this.props.onSetHalf} />
        <GapInput text="at" color="blank" />
        <GameDummyInput user={this.props.user} value={(this.props.game.matchExtra) ? this.props.game.matchExtra : ''} error={this.props.errors.extraTimeError} label="Set Extra Time" type="number" onValueChange={this.props.onSetExtra} />
      </div>
    );
  }
}

export class GameDummyInput extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      value: this.props.value
    }

    this.setValue = this.setValue.bind(this);
  }

  setValue(e) {
    //console.log(e.currentTarget.value)
    this.setState({
      value: e.currentTarget.value
    });
    this.props.onValueChange(e.currentTarget.value)
  }

  render() {
    return (
      <div className="add-game-input">
        <span>{this.props.label}</span>
        {this.props.type === "date" &&
          <input ref={(e) => FakeData.makeDatePicker(e, this.setValue)} type={"text"} value={this.state.value} onChange={() => { }} className={(this.props.error) ? 'error' : ''} />
        }
        {this.props.type === "time" &&
          <input ref={(e) => FakeData.makeTimePicker(e, this.setValue)} type={"text"} value={this.state.value} onChange={() => { }} className={(this.props.error) ? 'error' : ''} />
        }
        {(this.props.type !== "date" && this.props.type !== "time") &&
          <input type={this.props.type} value={this.state.value} onChange={(e) => this.setValue(e)} className={(this.props.error) ? 'error' : ''} />
        }
      </div>
    );
  }
}

export class GameDateTimeForm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="add-game-datetime">
        <GameDummyInput user={this.props.user} value={(this.props.game.matchDate) ? this.props.game.matchDate : ''} error={this.props.errors.dateError} label="Date" type="date" onValueChange={this.props.onSetDate} />
        <GapInput text="at" color="blank" />
        <GameDummyInput user={this.props.user} value={(this.props.game.matchTime) ? this.props.game.matchTime : ''} error={this.props.errors.timeError} label="Time" type="time" onValueChange={this.props.onSetTime} />
      </div>
    );
  }
}

export class GameAdminForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isFocus: false,
      people: this.props.data,
      filteredData: this.props.data,
      value: (this.props.game.matchAdmin) ? this.props.game.matchAdmin.name : '',
      nameTo: "",
      emailTo: "",
      emailError: false,
      nameError: false,
      isModalOpen: false
    }

    this.handleKeyup = this.handleKeyup.bind(this)
    this.selectItem = this.selectItem.bind(this)
    this.nameChange = this.nameChange.bind(this)
    this.emailChange = this.emailChange.bind(this)
    this.addAdmin = this.addAdmin.bind(this)
  }

  handleKeyup(e) {
    var bool = (e.target.value === "") ? false : true
    const val = e.target.value
    const newList = []
    this.state.people.forEach((person) => {
      if (person.name.toLowerCase().indexOf(val.toLowerCase()) > -1) {
        newList.push(person)
      }
    })

    this.setState({
      isFocus: bool,
      value: val,
      filteredData: newList
    })
  }

  selectItem(item) {
    if (item.id != null) {
      this.setState({
        isFocus: false,
        value: item.name
      });
      this.props.onPersonSelected(item)
    }
  }

  nameChange(e) {
    this.setState({
      nameTo: e.target.value,
      nameError: false
    });
  }

  emailChange(e) {
    const val = e.target.value
    if ((val.indexOf("@") == -1) || (val.indexOf(".") == -1)) {
      this.setState({
        emailTo: e.target.value,
        emailError: true
      })
    } else {
      this.setState({
        emailTo: e.target.value,
        emailError: false
      })
    }
  }

  addAdmin() {
    const _that = this

    if ((this.state.emailTo == "") || (this.state.emailTo == null)) {
      this.setState({
        emailError: true
      });

      return
    }

    if ((this.state.nameTo == "") || (this.state.nameTo == null)) {
      this.setState({
        nameError: true
      });

      return
    }

    const dataTo = {
      user: this.props.user,
      name: this.state.nameTo,
      email: this.state.emailTo
    }

    FakeData.post('/inviteAdmin.php?auth0', dataTo, {
      success: ((data) => {
        _that.selectItem(data)
        _that.setState({
          isModalOpen: false
        });
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    const items = this.state.filteredData
    return (
      <div className="add-game-admin">
        <div className="text-field" style={{ width: "100%" }}>
          <span>Gmc admin</span>
          <div className="input-for" onMouseLeave={() => this.setState({
            isFocus: false
          })}>
            <input value={this.state.value} className={(this.props.matchAdminError) ? 'error' : ''} onChange={(e) => this.handleKeyup(e)} />
            {this.state.isFocus &&
              <div className="list">
                <div key={"you"+9} onClick={() => this.selectItem({
                  id: FakeData.getData("yoo").id,
                  name: FakeData.getData("yoo").name,
                  image: FakeData.getData("yoo"),
                  user: FakeData.getData("yoo").username
                })} className="item"><img src={FakeData.getData("yoo").image} /><span>{"You"}</span></div>
                {items.map((i, pos) =>
                  <div key={pos} onClick={() => this.selectItem(i)} className="item"><img src={i.image} /><span>{i.name}</span></div>
                )}
              </div>
            }

            {((items.length <= 0) && (this.state.isFocus)) &&
              <div className="no-results">
                <span>No Results</span>
                <a onClick={() => this.setState({
                  isModalOpen: true
                })}>Invite</a>
              </div>
            }
          </div>
        </div>
        <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({
          isModalOpen: false
        })}>
          <div className="add-a-team">
            <h1>Invite Admin</h1>
            <div className="input-field">
              <span>Email</span>
              <input value={this.state.emailTo} onChange={this.emailChange} className={(this.state.emailError) ? 'error' : ''} />
            </div>
            <div className="input-field">
              <span>Name</span>
              <input value={this.state.nameTo} onChange={this.nameChange} className={(this.state.nameError) ? 'error' : ''} />
            </div>
            <button onClick={this.addAdmin}>Add</button>
          </div>
        </Modal>
      </div>
    );
  }
}

export class GameAdminHalfForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      types: ["Friendly", "Group Stages", "League", "Quarter Finals", "Semi Finals", "Finals"]
    }
  }

  render() {
    return (
      <div className="add-game-venue">
        <GameDummyInput user={this.props.user} value={(this.props.game.matchHalf) ? this.props.game.matchHalf : ''} error={this.props.errors.halfTimeError} label="Set Half Time" type="number" onValueChange={this.props.onSetHalf} />
        <GapInput text="at" color="blank" />
        <GameAdminForm user={this.props.user} game={this.props.game} matchAdminError={this.props.errors.matchAdminError} onPersonSelected={this.props.onPersonSelected} data={this.props.data} />
      </div>
    );
  }
}

export class GameVenueSportForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      types: ["Friendly", "Group Stages", "League", "Quarter Finals", "Semi Finals", "Finals"]
    }
  }

  render() {
    return (
      <div className="add-game-venue">
        <GameMatchCategoryField user={this.props.user} label="Sport" disabled={Boolean(this.props.game.sport)} value={(this.props.game.sport) ? this.props.game.sport.name : ''} error={this.props.errors.sportError} onSetType={this.props.onSportSelect} placeholder="Select Sport" data={this.props.sports} />
        <GapInput text="at" color="blank" />
        <GamePlaceField user={this.props.user} places={this.props.places} value={(this.props.game.matchPlace) ? this.props.game.matchPlace : ''} error={this.props.errors.matchError} onSetPlace={this.props.onSetPlace} />
      </div>
    );
  }
}

export class SportLeagueForm extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className="add-game-category">
        <GameMatchCategoryField user={this.props.user} label="Sport" value={(this.props.game.sport) ? this.props.game.sport.name : ''} error={this.props.errors.sportError} onSetType={this.props.onSportSelect} placeholder="Select Sport" data={this.props.sports} />
        <GapInput text="at" color="blank" />
        <GameMatchCategoryField user={this.props.user} label="League/Tournament" value={(this.props.game.tournament) ? this.props.game.tournament.name : ''} error={this.props.errors.tournamentError} onSetType={this.props.onLeagueSelect} placeholder="Select League" data={this.props.tourns} />
      </div>
    );
  }
}

export class GameMatchCategoryField extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSelecting: false,
      selectedItem: (this.props.value == '') ? this.props.placeholder : this.props.value
    }

    this.selectItem = this.selectItem.bind(this)
  }

  selectItem(item) {
    this.setState({
      selectedItem: item.name,
      isSelecting: false
    });

    this.props.onSetType(item)
  }

  render() {
    const items = this.props.data
    return (
      <div className="add-game-match-type">
        <span>{this.props.label}</span>
        <div className={(this.props.error) ? 'combo-box error' : 'combo-box'}>
          <div className="box-field" onClick={() => {
            if(this.props.disabled){
              return;
            }
            this.setState({
              isSelecting: (this.state.isSelecting) ? false : true
            })
          }}>
            <span className={this.props.disabled?"disabled":""}>{this.state.selectedItem}</span>
            <span></span>
          </div>
          {this.state.isSelecting && !this.props.disabled &&
            <div className="box-options" onMouseLeave={() => this.setState({
              isSelecting: false
            })}>
              {items.map((item, i) =>
                <div className="box-option" onClick={() => this.selectItem(item)} key={i}>{item.name}</div>
              )}
            </div>
          }
        </div>
      </div>
    );
  }
}

export class AddPlayersForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: (this.props.game.homeTeam.id == this.props.game.teamOne.id) ? 0 : 1,
      team: this.props.game.homeTeam,
      maxLineup: this.props.game.maxLineup,
      maxSubs: this.props.game.maxSubs
    }

    this.addLineUpPlayer = this.addLineUpPlayer.bind(this)
    this.addSubPlayer = this.addSubPlayer.bind(this)
    this.removeLineupPlayer = this.removeLineupPlayer.bind(this)
    this.removeSubPlayer = this.removeSubPlayer.bind(this)
  }

  addLineUpPlayer(player) {
    if ((this.props.game.homeTeam.lineup.indexOf(player) == -1) && (this.props.game.homeTeam.lineup.length < this.state.maxLineup)) {
      this.props.game.homeTeam.lineup.push(player)
      this.setState({
        team: this.props.game.homeTeam
      });
    }

    this.props.onLineupChange(this.props.game.homeTeam)
  }

  addSubPlayer(player) {
    if ((this.props.game.homeTeam.subs.indexOf(player) == -1) && (this.props.game.homeTeam.subs.length < this.state.maxSubs)) {
      this.props.game.homeTeam.subs.push(player)
      this.setState({
        team: this.props.game.homeTeam
      });
    }

    this.props.onLineupChange(this.props.game.homeTeam)
    this.setTab = this.setTab.bind(this)
  }

  removeLineupPlayer(player) {
    if (this.props.game.homeTeam.lineup.indexOf(player) != -1) {
      const index = this.props.game.homeTeam.lineup.indexOf(player)
      this.props.game.homeTeam.lineup.splice(index, 1)
      this.setState({
        team: this.props.game.homeTeam
      });
    }

    this.props.onLineupChange(this.props.game.homeTeam)
  }

  removeSubPlayer(player) {
    if (this.props.game.homeTeam.subs.indexOf(player) != -1) {
      const index = this.props.game.homeTeam.subs.indexOf(player)
      this.props.game.homeTeam.subs.splice(index, 1)
      this.setState({
        team: this.props.game.homeTeam
      });
    }

    this.props.onLineupChange(this.props.game.homeTeam)
  }

  setTab(int) {
    this.setState(prevState => ({
      activeTab: int
    }));
  }

  render() {
    const classOne = (this.props.game.homeTeam.id == this.props.game.teamOne.id) ? 'add-player-view home' : 'add-player-view away'
    const classTwo = (this.props.game.homeTeam.id == this.props.game.teamTwo.id) ? 'add-player-view home' : 'add-player-view away'
    if (!this.same) {
      return (
        <PitchConfig maxLineup={this.props.game.lineup} maxSubs={this.props.game.subs} onSave={this.props.onSave} game={this.props.game} />
      )
    }
    return (
      <div className="add-players-form">
        <div className="add-player-segment">
          <div className={(this.state.activeTab == 0) ? 'item active' : 'item'} onClick={() => this.setTab(0)}>{this.props.game.teamOne.name}</div>
          <div className={(this.state.activeTab == 1) ? 'item active' : 'item'} onClick={() => this.setTab(1)}>{this.props.game.teamTwo.name}</div>
        </div>
        {(this.state.activeTab == 0)
          ? <AddPlayerView game={this.props.game} onPlayerAdd={this.props.onNewPlayerAdded} maxSubs={this.state.maxSubs} maxLineup={this.state.maxLineup} onRemoveLineUp={this.removeLineupPlayer} onRemoveSub={this.removeSubPlayer} onAddLineUp={this.addLineUpPlayer} onAddSub={this.addSubPlayer} team={(this.props.game.homeTeam.id == this.props.game.teamOne.id) ? this.state.team : this.props.game.teamOne} otherTeam={(this.props.game.homeTeam.id == this.props.game.teamTwo.id) ? this.state.team : this.props.game.teamTwo} className={classOne} /> :
          <AddPlayerView game={this.props.game} onPlayerAdd={this.props.onNewPlayerAdded} maxSubs={this.state.maxSubs} maxLineup={this.state.maxLineup} team={(this.props.game.homeTeam.id == this.props.game.teamTwo.id) ? this.state.team : this.props.game.teamTwo} onRemoveLineUp={this.removeLineupPlayer} onRemoveSub={this.removeSubPlayer} onAddLineUp={this.addLineUpPlayer} onAddSub={this.addSubPlayer} otherTeam={(this.props.game.homeTeam.id == this.props.game.teamOne.id) ? this.state.team : this.props.game.teamOne} className={classTwo} />
        }
      </div>
    );
  }
}

export class AddPlayerView extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    if (this.props.className == "add-player-view away") {
      if (this.props.game.homeTeam.id == this.props.game.teamTwo.id) {
        return (
          <div className={this.props.className}>
            <AddPlayLineUpView team={this.props.team} />
            <AddPlayLineUpView team={this.props.otherTeam} />
          </div>
        )
      }

      return (
        <div className={this.props.className}>
          <AddPlayLineUpView team={this.props.otherTeam} />
          <AddPlayLineUpView team={this.props.team} />
        </div>
      );
    }

    return (
      <div className={this.props.className}>
        <AddPlayToLineUpView onPlayerAdd={this.props.onPlayerAdd} onRemoveLineUp={this.props.onRemoveLineUp} onRemoveSub={this.props.onRemoveSub} onAddLineUp={this.props.onAddLineUp} onAddSub={this.props.onAddSub} team={this.props.team} />
        <AddPlayLineUpView maxSubs={this.props.maxSubs} maxLineup={this.props.maxLineup} onRemoveLineUp={this.props.onRemoveLineUp} onRemoveSub={this.props.onRemoveSub} team={this.props.team} />
      </div>
    );
  }
}

export class PitchConfig extends Component {
  state = {
    activeTab: (this.props.game.homeTeam.squadId === this.props.game.teamOne.squadId) ? 0 : 1,
    isEditting: false,
    tokenOne: Date.now() + "one",
    tokenTwo: Date.now() + "two",
    openToken: Date.now()
  }

  setTab = (int) => {
    this.setState(prevState => ({
      activeTab: int
    }));
  }

  onSave = (players, lineup, subs) => {
    const _that = this
    this.props.onSave(players, lineup, subs, () => {
      _that.setState({
        isEditting: false,
        tokenOne: Date.now() + "one",
        tokenTwo: Date.now() + "two",
        openToken: Date.now()
      });
    })
  }

  render() {
    const { tokenOne, tokenTwo, openToken } = this.state
    return (
      <div className="pitch-config">
        <div className="pitch-config-header">
          <div className={(this.state.activeTab == 0) ? 'active' : ''} onClick={() => this.setTab(0)}>{this.props.game.teamOne.name}</div>
          <div className={(this.state.activeTab == 1) ? 'active' : ''} onClick={() => this.setTab(1)}>{this.props.game.teamTwo.name}</div>
        </div>
        <div className="pitch-config-body" style={{ height: "600px", width: "100%" }}>
          {(this.state.activeTab == 0) &&
            <div style={{ height: "600px", width: "100%" }}>
              <SoccerPitch key={tokenOne} maxLineup={this.props.maxLineup} isGMC={true} sport={this.props.game.sport.name} readOnly={true} team={this.props.game.teamOne} players={this.props.game.teamOne.players} maxSubs={this.props.maxSubs} lineup={this.props.game.teamOne.lineup} subs={this.props.game.teamOne.subs} />
              {(this.props.game.homeTeam.squadId === this.props.game.teamOne.squadId) &&
                <div className="pitch-config-body-edit" onClick={() => {
                  this.setState((state, props) => ({
                    isEditting: true,
                    openToken: Date.now(),
                    tokenOne: Date.now() + "one",
                    tokenTwo: Date.now() + "two"
                  }));
                }}>
                  <i className="material-icons">edit</i>
                </div>
              }
            </div>
          }
          {(this.state.activeTab == 1) &&
            <div style={{ height: "600px", width: "100%" }}>
              <SoccerPitch key={tokenTwo} maxLineup={this.props.maxLineup} isGMC={true} sport={this.props.game.sport.name} readOnly={true} team={this.props.game.teamTwo} players={this.props.game.teamTwo.players} maxSubs={this.props.maxSubs} lineup={this.props.game.teamTwo.lineup} subs={this.props.game.teamTwo.subs} />
              {(this.props.game.homeTeam.squadId === this.props.game.teamTwo.squadId) &&
                <div className="pitch-config-body-edit" onClick={() => {
                  this.setState((state, props) => ({
                    isEditting: true,
                    openToken: Date.now(),
                    tokenOne: Date.now() + "one",
                    tokenTwo: Date.now() + "two"
                  }));
                }}>
                  <i className="material-icons">edit</i>
                </div>
              }
            </div>
          }
        </div>
        <div className="pitch-config-footer">
          <div className={(this.state.activeTab == 0) ? 'active' : ''} onClick={() => this.setTab(0)} />
          <div className={(this.state.activeTab == 1) ? 'active' : ''} onClick={() => this.setTab(1)} />
        </div>
        {this.state.isEditting &&
          <Modal classes={"transparent-bg"} isTransparent={true} isOpen={this.state.isEditting} onClose={() => {
            this.setState((state, props) => ({
              isEditting: false,
              openToken: Date.now(),
              tokenOne: Date.now() + "one",
              tokenTwo: Date.now() + "two"
            }));
          }}>
            <div style={{ width: "950px", height: "500px" }}>
              <SoccerPitch onSave={this.onSave.bind(this)} key={openToken} maxLineup={this.props.maxLineup} isGMC={true} sport={this.props.game.sport.name} team={this.props.game.homeTeam} players={this.props.game.homeTeam.players} maxSubs={this.props.maxSubs} lineup={this.props.game.homeTeam.lineup} subs={this.props.game.homeTeam.subs} />
            </div>
          </Modal>
        }
      </div>
    );
  }
}

export class AddPlayToLineUpView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSubModal: false,
      isPlayerModal: false,
      sub: {
        name: "",
        position: "",
        jersey: 0,
        jerError: false,
        posError: false,
        nameError: false
      }
    }

    this.setPlayerVals = this.setPlayerVals.bind(this)
    this.addPlayer = this.addPlayer.bind(this)
    this.addSub = this.addSub.bind(this)
  }

  setPlayerVals(key, e) {
    if (key == "name") {
      this.state.sub.name = e.target.value
      this.state.sub.nameError = false
      this.setState({
        sub: this.state.sub
      });
    } else if (key == "pos") {
      this.state.sub.position = e.target.value
      this.state.sub.posError = false
      this.setState({
        sub: this.state.sub
      });
    } else {
      const val = e.target.value
      if (val <= 0) {
        this.state.sub.jerError = true
        this.state.sub.jersey = val
        this.setState({
          sub: this.state.sub
        });
      } else {
        this.state.sub.jersey = val
        this.state.sub.jerError = false
        this.setState({
          sub: this.state.sub
        });
      }
    }
  }

  addPlayer() {
    if (this.state.sub.name == "") {
      this.state.sub.nameError = true
      this.setState({
        sub: this.state.sub
      });
      return
    }

    if (this.state.sub.position == "") {
      this.state.sub.posError = true
      this.setState({
        sub: this.state.sub
      });
      return
    }

    if (this.state.sub.jersey <= 0) {
      this.state.sub.jerError = true
      this.setState({
        sub: this.state.sub
      });
      return
    }

    const _that = this
    const dataTo = {
      name: this.state.sub.name,
      position: this.state.sub.position,
      jersey: this.state.sub.jersey,
      teamId: this.props.team.id,
      squadId: this.props.team.squadId
    }

    FakeData.post('/createNewPlayer.php?auth0', dataTo, {
      success: ((data) => {
        const newPlayer = data
        _that.props.onAddLineUp(newPlayer)
        _that.props.onPlayerAdd(newPlayer)

        _that.setState({
          isPlayerModal: false,
          sub: {
            name: "",
            position: "",
            jersey: 0,
            jerError: false,
            posError: false,
            nameError: false
          }
        })
      }),
      error: ((err) => {

      })
    })
  }

  addSub() {
    if (this.state.sub.name == "") {
      this.state.sub.nameError = true
      this.setState({
        sub: this.state.sub
      });
      return
    }

    if (this.state.sub.position == "") {
      this.state.sub.posError = true
      this.setState({
        sub: this.state.sub
      });
      return
    }

    if (this.state.sub.jersey <= 0) {
      this.state.sub.jerError = true
      this.setState({
        sub: this.state.sub
      });
      return
    }

    const _that = this
    const dataTo = {
      name: this.state.sub.name,
      position: this.state.sub.position,
      jersey: this.state.sub.jersey,
      teamId: this.props.team.id,
      squadId: this.props.team.squadId
    }

    FakeData.post('/createNewPlayer.php?auth0', dataTo, {
      success: ((data) => {
        const newPlayer = data
        _that.props.onAddSub(newPlayer)
        _that.props.onPlayerAdd(newPlayer)
        _that.setState({
          isSubModal: false,
          sub: {
            name: "",
            position: "",
            jersey: 0,
            jerError: false,
            posError: false,
            nameError: false
          }
        })
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    const players = this.props.team.players
    const subs = this.props.team.players
    return (
      <div className="add-player-to">
        <h1>Add Starting Players</h1>
        <div className="players setup">
          {
            players.map((item, i) =>
              <div key={i} className={(i % 2 != 0) ? "player even" : "player"}>
                <span className="name">{item.name}</span>
                <span className="position">{item.position}</span>
                <span className="number">{item.number}</span>
                <div style={{ width: "15%", padding: "5px 0 0 0" }} className="add_player_meta" onClick={() => this.props.onAddLineUp(item)}><div className="manage_add_results">Add</div></div>
              </div>
            )
          }
        </div>

        <button className="button" onClick={() => this.setState({
          isPlayerModal: true
        })}>Add New Starting Player</button>

        <h1>Add Substitute Players</h1>
        <div className="players setup">
          {
            subs.map((item, i) =>
              <div key={i} className={(i % 2 == 0) ? "player even" : "player"}>
                <span className="name">{item.name}</span>
                <span className="position">{item.position}</span>
                <span className="number">{item.number}</span>
                <div style={{ width: "15%", padding: "5px 0 0 0" }} className="add_player_meta" onClick={() => this.props.onAddSub(item)}><div className="manage_add_results">Add</div></div>
              </div>
            )
          }
        </div>

        <button className="button" onClick={() => this.setState({
          isSubModal: true
        })}>Add New Substitute Player</button>

        <Modal isOpen={this.state.isSubModal} onClose={() => this.setState({
          isSubModal: false,
          sub: {
            name: "",
            position: "",
            jersey: 0,
            jerError: false,
            posError: false,
            nameError: false
          }
        })}>
          <div className="add-place">
            <h1>Add Player</h1>

            <div className="input-field">
              <span>Player Name</span>
              <input className={(this.state.sub.nameError) ? 'error' : ''} onChange={(e) => this.setPlayerVals('name', e)} value={this.state.sub.name} />
            </div>
            <div className="split-input">
              <div className="input-field">
                <span>Position</span>
                <input className={(this.state.sub.posError) ? 'error' : ''} onChange={(e) => this.setPlayerVals('pos', e)} value={this.state.sub.position} />
              </div>
              <div className="input-field">
                <span>Jersey</span>
                <input type="number" className={(this.state.sub.jerError) ? 'error' : ''} onChange={(e) => this.setPlayerVals('jer', e)} value={this.state.sub.Jersey} />
              </div>
            </div>
            <button onClick={this.addSub}>Add Place</button>
          </div>
        </Modal>

        <Modal isOpen={this.state.isPlayerModal} onClose={() => this.setState({
          isPlayerModal: false,
          sub: {
            name: "",
            position: "",
            jersey: 0,
            jerError: false,
            posError: false,
            nameError: false
          }
        })}>
          <div className="add-place">
            <h1>Add Player</h1>

            <div className="input-field">
              <span>Player Name</span>
              <input className={(this.state.sub.nameError) ? 'error' : ''} onChange={(e) => this.setPlayerVals('name', e)} value={this.state.sub.name} />
            </div>
            <div className="split-input">
              <div className="input-field">
                <span>Position</span>
                <input className={(this.state.sub.posError) ? 'error' : ''} onChange={(e) => this.setPlayerVals('pos', e)} value={this.state.sub.position} />
              </div>
              <div className="input-field">
                <span>Jersey</span>
                <input type="number" className={(this.state.sub.jerError) ? 'error' : ''} onChange={(e) => this.setPlayerVals('jer', e)} value={this.state.sub.jersey} />
              </div>
            </div>
            <button onClick={this.addPlayer}>Add</button>
          </div>
        </Modal>
      </div>
    );
  }
}

export class AddPlayLineUpView extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const players = this.props.team.lineup
    const subs = this.props.team.subs
    return (
      <div className="add-player-lineup">
        <h1>Add Starting Players</h1>
        <div className="players-head">
          <span>Player</span>
          <span>Position</span>
          <span>Jersey</span>
          {(this.props.onRemoveLineUp) && <span></span>}
        </div>
        {players.length > 0 &&
          <div className="players lineuplist">
            {
              players.map((item, i) =>
                <div key={i} className={(i % 2 != 0) ? "player even" : "player"}>
                  <span className="name">{item.name}</span>
                  <span className="position">{item.position}</span>
                  <span className="number">{item.number}</span>
                  {(this.props.onRemoveLineUp) &&
                    <div className="lineup_manage" onClick={() => this.props.onRemoveLineUp(item)}><div className="manage_gmc_delete"></div></div>
                  }
                </div>
              )
            }
          </div>
        }

        {players.length == 0 &&
          <div className="players empty">
            <span>Squad not set</span>
          </div>
        }

        <h1>Substitute Players</h1>
        <div className="players-head">
          <span>Player</span>
          <span>Position</span>
          <span>Jersey</span>
          {(this.props.onRemoveLineUp) && <span></span>}
        </div>
        {subs.length > 0 &&
          <div className="players sublist">
            {
              subs.map((item, i) =>
                <div key={i} className={(i % 2 == 0) ? "player even" : "player"}>
                  <span className="name">{item.name}</span>
                  <span className="position">{item.position}</span>
                  <span className="number">{item.number}</span>
                  {(this.props.onRemoveSub) &&
                    <div className="lineup_manage" onClick={() => this.props.onRemoveSub(item)}><div className="manage_gmc_delete"></div></div>
                  }
                </div>
              )
            }
          </div>
        }
        {subs.length == 0 &&
          <div className="players empty">
            <span>Squad not set</span>
          </div>
        }
      </div>
    );
  }
}

export class GmcFixture extends React.Component {
  constructor(props) {
    super(props)
    this.state = {

    }
  }

  render() {
    const matchDate = new Date(this.props.game.fullDate);
    const today = new Date();
    const isReady = matchDate.setHours(0,0,0,0) === today.setHours(0,0,0,0)?true:false
    return (
      <div className={"fixture " + this.props.class}>
        <div className="fixture-details">
          <span className="detail-title">{this.props.game.teamOne.name} vs {this.props.game.teamTwo.name}</span>
          <span className="detail-time">{this.props.game.matchTime}</span>
          <span className="detail-date">{this.props.game.matchDate}</span>
          <span className="detail-type">{this.props.game.matchType}</span>
          <span className="detail-place">{this.props.game.matchPlace}</span>
          <div className="detail-actions">
            {isReady && <div className="manage_gmc_edit"><Link  to={'/console/' + this.props.game.id}>Open GMC</Link></div>}
            {!isReady && <div className=""><a>Coming Soon</a></div>}
          </div>
        </div>
      </div>
    );
  }
}

export class Fixture extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      isAddingResults: false,
      isDeleting: false,
      types: ["Draw", "Win", "Lose"],
      valueTwo: this.props.results.teamTwoStats,
      valueOne: this.props.results.teamOneStats,
      pointsValueOne: 1,
      pointsValueTwo: 1,
      firstError: false,
      secondError: false,
      extraError: false,
      extraTime: Math.floor(this.props.game.matchExtra),
      firstTime: this.props.game.matchHalf,
      secondTime: this.props.game.matchHalf,
      assigns: {
        teamOne: {
          Goals: []
        }, teamTwo: {
          Goals: []
        }, teamOneMaster: {}, teamTwoMaster: {}
      }
    }

    this.setResultsOne = this.setResultsOne.bind(this)
    this.setResultsTwo = this.setResultsTwo.bind(this)
  }

  setResultsOne(val) {
    switch (val) {
      case "Win":
        this.setState({
          valueTwo: "Lose",
          valueOne: "Win",
          pointsValueTwo: 0,
          pointsValueOne: 3
        })
        break;
      case "Lose":
        this.setState({
          valueTwo: "Win",
          valueOne: "Lose",
          pointsValueTwo: 3,
          pointsValueOne: 0
        })
        break;
      case "Draw":
        this.setState({
          valueTwo: "Draw",
          valueOne: "Draw",
          pointsValueTwo: 1,
          pointsValueOne: 1
        })
        break;
    }
  }

  setResultsTwo(val) {
    switch (val) {
      case "Win":
        this.setState({
          valueTwo: "Win",
          valueOne: "Lose",
          pointsValueTwo: 3,
          pointsValueOne: 0
        })
        break;
      case "Lose":
        this.setState({
          valueTwo: "Lose",
          valueOne: "Win",
          pointsValueTwo: 0,
          pointsValueOne: 3
        })
        break;
      case "Draw":
        this.setState({
          valueTwo: "Draw",
          valueOne: "Draw",
          pointsValueTwo: 1,
          pointsValueOne: 1
        })
        break;
    }
  }

  setValue(key, e) {
    if (key == "extra") {
      if (e.target.value <= 0) {
        this.setState({
          extraTime: e.target.value,
          extraError: true
        });
      } else {
        this.setState({
          extraTime: e.target.value,
          extraError: false
        });
      }
    } else if (key == "second") {
      if (e.target.value <= 0) {
        this.setState({
          secondTime: e.target.value,
          secondError: true
        });
      } else {
        this.setState({
          secondTime: e.target.value,
          secondError: false
        });
      }
    } else if (key == "first") {
      if (e.target.value <= 0) {
        this.setState({
          firstTime: e.target.value,
          firstError: true
        });
      } else {
        this.setState({
          firstTime: e.target.value,
          firstError: false
        });
      }
    }
  }

  onChangedAssign(team, key, array, defaultValue) {
    this.state.assigns[team][key] = array
    this.state.assigns[team + "Master"][key] = array.length + defaultValue
    this.setState({
      assigns: this.state.assigns
    });
  }

  deleteGame() {
    const _that = this
    const dataTo = {
      gameId: this.props.game.id
    }

    FakeData.post("/deleteGame.php?auth0", dataTo, {
      success: ((res) => {
        console.log(res);
        _that.setState({
          isDeleting: false
        });
        if(_that.props.onRefreshData){
          setTimeout(()=>{_that.props.onRefreshData()},1000)
        }
      }),
      error: ((err) => {

      })
    },true, "", null)
  }

  onSave() {
    if (((this.state.valueOne == "Win") && (this.state.assigns['teamOne']['Goals'].length <= this.state.assigns['teamTwo']['Goals'].length)) || ((this.state.valueTwo == "Win") && (this.state.assigns['teamOne']['Goals'].length >= this.state.assigns['teamTwo']['Goals'].length))) {
      console.log("Error on goals");

      return
    } else if (((this.state.valueOne == "Win") && (this.state.assigns['teamOneMaster']['Points'] <= this.state.assigns['teamTwoMaster']['Points'])) || ((this.state.valueTwo == "Win") && (this.state.assigns['teamOneMaster']['Points'] >= this.state.assigns['teamTwoMaster']['Points']))) {
      console.log("Error on points");

      return
    } else if (((this.state.valueOne == "Draw") && (this.state.assigns['teamOne']['Goals'].length < this.state.assigns['teamTwo']['Goals'].length)) || ((this.state.valueTwo == "Draw") && (this.state.assigns['teamOne']['Goals'].length > this.state.assigns['teamTwo']['Goals'].length))) {
      console.log("Error on draw");

      return
    }

    const dataTo = {
      gameId: this.props.game.id,
      game: this.props.game,
      teamOneData: this.state.assigns['teamOne'],
      teamTwoData: this.state.assigns['teamTwo'],
      teamOneMaster: this.state.assigns['teamOneMaster'],
      teamTwoMaster: this.state.assigns['teamTwoMaster'],
      sport: this.props.game.sport,
      resOne: this.state.valueOne,
      resTwo: this.state.valueTwo,
      firstHalf: this.state.firstTime,
      secondHalf: this.state.secondTime,
      extraHalf: this.state.extraTime,
      pointsValueOne: this.state.pointsValueOne,
      pointsValueTwo: this.state.pointsValueTwo
    }

    //console.log(dataTo);
    const _that = this;
    FakeData.post('/saveGameResults.php?auth0', dataTo, {
      success: ((res) => {
        if(_that.props.onRefreshData){
          setTimeout(()=>{_that.props.onRefreshData()},1000)
        }
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    return (
      <div className={"fixture " + this.props.class}>
        <div className="fixture-details">
          <span className="detail-title">{this.props.game.teamOne.name} vs {this.props.game.teamTwo.name}</span>
          <span className="detail-time">{this.props.game.matchTime}</span>
          <span className="detail-date">{this.props.game.matchDate}</span>
          <span className="detail-type">{this.props.game.matchType}</span>
          <span className="detail-place">{this.props.game.matchPlace}</span>
          <div className="detail-actions">
            <div className="manage_add_results" onClick={() => this.setState({
              isAddingResults: (this.state.isAddingResults) ? false : true
            })}>Add Result</div>
            <div className="manage_gmc_edit" onClick={() => {
              if ((this.props.game.currentTime > 0)) {
                return
              }
              this.setState({ isModalOpen: true })
            }}>Edit</div>
            <div className="manage_gmc_delete" onClick={() => this.setState({
              isDeleting: (this.state.isDeleting) ? false : true
            })}>Delete</div>
          </div>
        </div>
        {this.state.isAddingResults &&
          <div className="fixture-results">
            <div className="flex-gap">
              <div className="input-field">
                <span>First Half</span>
                <input type="number" className={(this.state.firstError) ? 'error' : ''} onChange={(e) => this.setValue('first', e)} value={this.state.firstTime} />
              </div>
              <div className="input-field">
                <span>Second Half</span>
                <input type="number" className={(this.state.secondError) ? 'error' : ''} onChange={(e) => this.setValue('second', e)} value={this.state.secondTime} />
              </div>
              <div className="input-field">
                <span>Extra Time</span>
                <input type="number" className={(this.state.extraError) ? 'error' : ''} onChange={(e) => this.setValue('extra', e)} value={this.state.extraTime} />
              </div>
            </div>
            <div className="results-title">
              <h1>{this.props.game.teamOne.name}</h1>
              <span>VS</span>
              <h1>{this.props.game.teamTwo.name}</h1>
            </div>
            <div className="flex-gap">
              <ComboBox label="Result" fixture="true" width="29.65em" onSelectedItem={this.setResultsOne} placeholder={this.state.valueOne} data={this.state.types} />
              <ComboBox label="Result" fixture="true" width="29.65em" onSelectedItem={this.setResultsTwo} placeholder={this.state.valueTwo} data={this.state.types} />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.props.results.teamOneGoals.length} onApply={(array, defVal) => this.onChangedAssign("teamOne", "Goals", array, defVal)} game={this.props.game} team={this.props.game.teamOne} label="Goals" />
              <AssignToPlayer value={this.props.results.teamOneGoals.length} onApply={(array, defVal) => this.onChangedAssign("teamTwo", "Goals", array, defVal)} game={this.props.game} team={this.props.game.teamTwo} label="Goals" />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.state.pointsValueOne} game={this.props.game} hideAction="true" onApply={(array, defVal) => this.onChangedAssign("teamOne", "Points", array)} team={this.props.game.teamOne} label="Points Earned" />
              <AssignToPlayer value={this.state.pointsValueTwo} game={this.props.game} hideAction="true" onApply={(array, defVal) => this.onChangedAssign("teamTwo", "Points", array)} team={this.props.game.teamTwo} label="Points Earned" />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.props.results.teamOneFouls.length} onApply={(array, defVal) => this.onChangedAssign("teamOne", "Fouls", array, defVal)} game={this.props.game} team={this.props.game.teamOne} label="Fouls" />
              <AssignToPlayer value={this.props.results.teamTwoFouls.length} onApply={(array, defVal) => this.onChangedAssign("teamTwo", "Fouls", array, defVal)} game={this.props.game} team={this.props.game.teamTwo} label="Fouls" />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.props.results.teamOneRC.length} onApply={(array, defVal) => this.onChangedAssign("teamOne", "RC", array, defVal)} game={this.props.game} team={this.props.game.teamOne} label="Red Card" />
              <AssignToPlayer value={this.props.results.teamTwoYC.length} onApply={(array, defVal) => this.onChangedAssign("teamTwo", "RC", array, defVal)} game={this.props.game} team={this.props.game.teamTwo} label="Red Card" />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.props.results.teamOneYC.length} onApply={(array, defVal) => this.onChangedAssign("teamOne", "YC", array, defVal)} game={this.props.game} team={this.props.game.teamOne} label="Yellow Card" />
              <AssignToPlayer value={this.props.results.teamTwoYC.length} onApply={(array, defVal) => this.onChangedAssign("teamTwo", "YC", array, defVal)} game={this.props.game} team={this.props.game.teamTwo} label="Yellow Card" />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.props.results.teamOneCorners.length} onApply={(array, defVal) => this.onChangedAssign("teamOne", "Corners", array, defVal)} game={this.props.game} team={this.props.game.teamOne} label="Corners" />
              <AssignToPlayer value={this.props.results.teamTwoCorners.length} onApply={(array, defVal) => this.onChangedAssign("teamTwo", "Corners", array, defVal)} game={this.props.game} team={this.props.game.teamTwo} label="Corners" />
            </div>
            <div className="flex-gap">
              <AssignToPlayer value={this.props.results.teamOneShots.length} onApply={(array, defVal) => this.onChangedAssign("teamOne", "Shots", array, defVal)} game={this.props.game} team={this.props.game.teamOne} label="Shot On Target" />
              <AssignToPlayer value={this.props.results.teamTwoShots.length} onApply={(array, defVal) => this.onChangedAssign("teamTwo", "Shots", array, defVal)} game={this.props.game} team={this.props.game.teamTwo} label="Shot On Target" />
            </div>

            <button className="odd-button" style={{ lineHeight: "40px", width: "100%", border: "none", background: "#4EA3C9", color: "#fff" }} onClick={() => this.onSave()}>Save Results</button>
          </div>
        }

        {this.state.isDeleting &&
          <h1 className="is-your-team" style={{ margin: "15px" }}>Are you sure want to delete this game? <button onClick={() => this.deleteGame()}>Yes</button><button onClick={() => this.setState({ isDeleting: false })}>No</button></h1>
        }

        <EditGameModal isOpen={this.state.isModalOpen} user={this.props.user} game={this.props.game} onClose={() => this.setState({ isModalOpen: false })} />

      </div>
    );
  }
}

export class AssignToPlayer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isError: false,
      value: 0,
      goalsLeft: 0,
      isModalOpen: false,
      selectedPlayers: {},
      isPlayerError: false,
    }

    this.setValue = this.setValue.bind(this)
    this.onSelect = this.onSelect.bind(this)
  }

  setValue(e) {
    let val = e.target.value
    if (val < 0) {
      this.setState({
        isError: true,
        value: val,
        goalsLeft: val
      });
    } else {
      this.setState({
        isError: false,
        value: val,
        goalsLeft: val
      });
    }
  }

  onSelect(player, goals) {
    const goal = {
      player: player,
      goals: goals
    }

    if (goals.length <= 0) {
      delete this.state.selectedPlayers[player.id]
      this.setState({
        selectedPlayers: this.state.selectedPlayers
      });
    } else {
      this.state.selectedPlayers[player.id] = goal
      this.setState({
        selectedPlayers: this.state.selectedPlayers
      });
    }

    this.reCalculateGoalsLeft()
  }

  reCalculateGoalsLeft() {
    let val = this.state.value
    for (var prop in this.state.selectedPlayers) {
      const goalsFor = this.state.selectedPlayers[prop]['goals']
      val = (val - goalsFor.length)
    }

    this.setState({
      goalsLeft: val
    });
  }

  onAssign() {
    if (this.state.value <= 0) {
      return
    }

    this.setState({
      isModalOpen: true
    });
  }

  onApply() {
    const arr = []
    let bool = true
    for (var prop in this.state.selectedPlayers) {
      const obj = this.state.selectedPlayers[prop]
      obj.goals.forEach((item, i) => {
        if ((!item.isSecondHalf) && (!item.isFirstHalf) && (!item.isExtraTime)) {
          bool = false
          this.setState({
            isPlayerError: true
          });
          return
        } else {
          this.setState({
            isPlayerError: false
          });
        }
      })
      arr.push(obj)
      //console.log(obj);
    }

    if (arr.length < this.state.value) {
      this.setState({
        isPlayerError: true
      });

      return
    } else {
      this.setState({
        isPlayerError: false,
        isModalOpen: false
      });
      this.props.onApply(arr, this.props.value)
    }
  }

  render() {
    return (
      <div className="assign-player-input">
        <div className="input-field">
          <span>{this.props.label}</span>
          <input type="number" disabled={(this.props.hideAction) ? true : false} className={(this.state.isError) ? 'error' : ''} onChange={(e) => this.setValue(e)} value={(this.props.hideAction) ? this.props.value : this.state.value} />
        </div>
        {!this.props.hideAction &&
          <div className="add_result_player" onClick={() => this.onAssign()}>Assign Player</div>
        }
        <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({ isModalOpen: false })}>
          <div className="add-place" style={{ width: "850px" }}>
            <h1>Select Players</h1>
            {this.state.isPlayerError &&
              <blockquote style={{ display: "block", color: "brown", fontWeight: 500 }}>
                <span>Add First, Second or Extra time for each player action</span>
              </blockquote>
            }
            <div className="col-headings">
              <div><h3 className="">Goals</h3></div>
              <div><h3 className="sec">First Half</h3></div>
              <div><h3 className="fir">Second Half</h3></div>
              <div><h3 className="extra">Extra time</h3></div>
            </div>
            <div style={{ overflowY: "auto", maxHeight: "500px" }} className={(this.state.isPlayerError) ? "error" : ""}>
              {
                this.props.team.players.map((item, i) =>
                  <AssigneePlayer goalsLeft={this.state.goalsLeft} isOdd={(i % 2 != 0) ? true : false} player={item} key={i} onSelectFor={this.onSelect} />
                )
              }
            </div>
            <button className="odd-button" style={{ lineHeight: "40px", width: "100%", border: "none", background: "#4EA3C9", color: "#fff" }} onClick={() => this.onApply()}>Apply</button>
          </div>
        </Modal>
      </div>
    )
  }
}

export class AssigneePlayer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      goals: []
    }
  }

  setGoalsLeft(num) {
    const arr = []
    for (let i = 1; i <= num; i++) {
      arr.push(i)
    }

    return arr
  }

  select(e) {
    const val = e.target.value
    this.setState({
      goals: []
    });

    for (let i = 0; i < val; i++) {
      const goal = {
        index: this.makeid(val + Math.floor(Math.random() * (i + 2))),
        isFirstHalf: false,
        isSecondHalf: false,
        isExtraTime: false,
        min: 0
      }

      this.state.goals.push(goal)
      this.setState({
        goals: this.state.goals
      });
    }


    this.props.onSelectFor(this.props.player, this.state.goals)
  }

  makeid(len) {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < len; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  onRemoveGoal(goal, index) {
    this.state.goals.forEach((item) => {
      if (item.index == goal.index) {
        this.state.goals.splice(index, 1)
        this.setState({
          goals: this.state.goals
        });

        this.props.onSelectFor(this.props.player, this.state.goals)
      }
    })
  }

  onUpdate(goal) {
    this.state.goals.forEach((item) => {
      if (item.index == goal.index) {
        item = goal
        this.setState({
          goals: this.state.goals
        });

        this.props.onSelectFor(this.props.player, this.state.goals)
      }
    })
  }

  render() {
    const goalsLeft = this.setGoalsLeft(parseInt(this.props.goalsLeft))
    return (
      <div className={(!this.props.isOdd) ? "assignee-player odd" : "assignee-player"}>
        <div className="assignee-player-name">
          <span>{this.props.player.name}</span>
          <select onChange={(e) => this.select(e)} style={{ background: "none" }}>
            <option value={this.state.goals.length} selected={(this.state.goals.length == 0) ? true : false}>{this.state.goals.length}</option>
            {
              goalsLeft.map((item, i) =>
                <option value={item} key={i} selected={(this.state.goals.length == item) ? true : false}>{item}</option>
              )
            }
          </select>
        </div>
        <div className="assignee-player-time">
          {
            this.state.goals.map((item, i) =>
              <AddTime keyVal="first" onRemoveGoal={(goal) => this.onRemoveGoal(goal)} key={i} goal={item} onUpdate={(goal) => this.onUpdate(goal)} />
            )
          }
        </div>
        <div className="assignee-player-time">
          {
            this.state.goals.map((item, i) =>
              <AddTime keyVal="second" onRemoveGoal={(goal) => this.onRemoveGoal(goal)} key={i} goal={item} onUpdate={(goal) => this.onUpdate(goal)} />
            )
          }
        </div>
        <div className="assignee-player-time">
          {
            this.state.goals.map((item, i) =>
              <AddTime keyVal="extra" onRemoveGoal={(goal) => this.onRemoveGoal(goal, i)} key={i} goal={item} onUpdate={(goal) => this.onUpdate(goal)} />
            )
          }
        </div>
      </div>
    );
  }
}

export class AddTime extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: (this.props.goal.min <= 0) ? false : true,
      value: this.props.goal.min,
      isError: false
    }
  }

  onValueChanged(val) {
    this.setState({
      value: val
    })

    if (val <= 0) {
      let goal = this.props.goal
      goal.isSecondHalf = false
      goal.isFirstHalf = false
      goal.isExtraTime = false
      goal.min = val

      this.setState({
        isError: true
      });

      this.props.onUpdate(goal)
    } else if (val <= 45 && (this.props.keyVal == "second")) {
      let goal = this.props.goal
      goal.isSecondHalf = false
      goal.isFirstHalf = false
      goal.isExtraTime = false
      goal.min = val

      this.setState({
        isError: true
      });

      this.props.onUpdate(goal)
    } else {
      this.setState({
        isError: false
      });

      if (this.props.keyVal == "extra") {
        let goal = this.props.goal
        goal.isSecondHalf = false
        goal.isFirstHalf = false
        goal.isExtraTime = true
        goal.min = val

        this.props.onUpdate(goal)
      } else if (this.props.keyVal == "first") {
        let goal = this.props.goal
        goal.isSecondHalf = false
        goal.isFirstHalf = true
        goal.isExtraTime = false
        goal.min = val

        this.props.onUpdate(goal)
      } else {
        let goal = this.props.goal
        goal.isSecondHalf = true
        goal.isFirstHalf = false
        goal.isExtraTime = false
        goal.min = val

        this.props.onUpdate(goal)
      }
    }
  }

  render() {
    return (
      <div className="assignee-player-time-holder">
        {!this.state.isEditting &&
          <span className="add-time-for" onClick={() => {
            if ((this.props.keyVal == "first") && ((this.props.goal.isExtraTime) || (this.props.goal.isSecondHalf)) && (this.props.goal.min > 0)) {
              return
            } else if ((this.props.keyVal == "second") && ((this.props.goal.isExtraTime) || (this.props.goal.isFirstHalf)) && (this.props.goal.min > 45)) {
              return
            } else if ((this.props.keyVal == "extra") && ((this.props.goal.isFirstHalf) || (this.props.goal.isSecondHalf)) && (this.props.goal.min > 0)) {
              return
            } else {
              this.setState({ isEditting: true })
            }
          }}>Add Time</span>
        }
        {this.state.isEditting &&
          <input type="number" className={(this.state.isError) ? "error" : ""} value={this.state.value} onChange={(e) => this.onValueChanged(e.target.value)} />
        }
        <span style={{ margin: "0px 10px", cursor: "pointer" }} onClick={() => this.props.onRemoveGoal(this.props.goal)}>x</span>
      </div>
    );
  }
}

export class GMCCoreHeader extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      isGameModalOpen: false,
      hasGameWindow: false,
      isLive: false
    }

    this.onSaveLineUp = this.onSaveLineUp.bind(this)
  }

  componentDidMount(){
    this._isMounted = true;
    this.checkGame();
    this.checkIfIsLive()
  }

  checkGame = () => {
    const _that = this;
    const _data = {
      id: this.props.game.id
    }

    FakeData.post('https://supotsu.com:8080/get-live-game', _data, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        if(res.error){
          _that.setState({
            hasGameWindow:false
          })
          if(!_that.props.game.isEnded && !_that.props.game.isPlaying){
            _that.registerGameWindow();
          }
        } else{
          _that.setState({
            hasGameWindow:true
          })

          setTimeout(()=>{
            _that.checkGame()
          }, 5000)
        }
      }),
      error: ((err) => {
        
      })
    })
  }

  registerGameWindow = () => {
    const _that = this;
    const _data = {
      id: this.props.game.id,
      data: this.props.game
    }

    FakeData.post('https://supotsu.com:8080/set-live-game', _data, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        if(res.error){
          _that.setState({
            hasGameWindow:false
          })
        } else{
          _that.setState({
            hasGameWindow:true
          })
        }
      }),
      error: ((err) => {
        
      })
    })
  }

  onSaveLineUp(t1, t2) {
    const _that = this
    _that.setState({
      isModalOpen: false
    });
  }

  checkIfIsLive = () => {
    const _that = this;
    const _key = this.props.game.teamOne.squadId + new Date(this.props.game.fullDate).getTime() + this.props.game.teamTwo.squadId
    const _data = {
      key: _key
    }

    FakeData.post('https://supotsu.com:8080/check-live-game', _data, {
      success: ((res) => {
        if (!_that._isMounted) {
          return
        }
        if(res.error){
          _that.setState({
            isLive:false
          })
        } else{
          _that.setState({
            isLive:true
          })
        }
        setTimeout(()=>{
          _that.checkIfIsLive()
        }, 5000)
      }),
      error: ((err) => {
        
      })
    })
  }

  render() {
    const {isLive} = this.state;
    return (
      <div className="gmc_timers">
        <ul>
          <li className="gmc_first sw_start" onClick={this.props.onStartFirstHalf}>Start First Half</li>
          <li className="gmc_second sw_start" onClick={this.props.onStartSecondHalf}>Start Second Half</li>
          <li className="gmc_pause" id="sw_pause" onClick={this.props.onPause}></li>
          <li className="gmc_reset" id="sw_reset" onClick={this.props.onReset}></li>
          <li><a className="" id="sw_end" onClick={this.props.onEnd}>End</a></li>
          <li className={(this.state.hasGameWindow) ? "disabled" : ""} onClick={() => {
            if (this.state.hasGameWindow || !this.props.game.isAdmin) {
              return
            }
            this.setState({
              isGameModalOpen: true,
              hasGameWindow: true
            })
          }} style={{
            background: "red",
            textAlign: "center",
            padding: "0px 10px",
            color: "#fff"
          }}>{isLive?"Streaming...":(this.state.hasGameWindow?"Ready to Stream":"Live Stream")}</li>

          <li className={((this.props.game.currentTime > 0) || (!this.props.game.isAdmin)) ? "gmc_save_draft disabled" : "gmc_save_draft"} onClick={() => {
            if ((this.props.game.currentTime > 0) || (!this.props.game.isAdmin)) {
              return
            }
            this.setState({
              isModalOpen: true
            })
          }}>Verify Players</li>
        </ul>
        {this.state.isModalOpen &&
          <Modal isOpen={this.state.isModalOpen} onClose={() =>
            this.setState({
              isModalOpen: false
            })
          }>
            <div className="verify-players">
              <VerifyPlayersForm onSaveLineUp={this.onSaveLineUp} onLineupChangeOne={this.props.onLineupChangeOne} onLineupChangeTwo={this.props.onLineupChangeTwo} onNewPlayerAddedTeamOne={this.props.addPlayerTeamOne} onNewPlayerAddedTeamTwo={this.props.addPlayerTeamTwo} user={this.props.user} game={this.props.game} />
            </div>
          </Modal>
        }
        {this.state.isGameModalOpen &&
          <WindowGMCStreamPortal id={this.props.game.id} isOpen={this.state.isGameModalOpen}/>
        }
      </div>
    );
  }
}

class WindowGMCStreamPortal extends React.PureComponent {
  constructor(props) {
    super(props);
    // STEP 1: create a container <div>
    this.containerEl = document.createElement('div');
    this.externalWindow = null;
  }
  
  render() {
    // STEP 2: append props.children to the container <div> that isn't mounted anywhere yet
    return ReactDOM.createPortal(this.props.children, this.containerEl);
  }

  componentDidMount() {
    // STEP 3: open a new browser window and store a reference to it
    this.externalWindow = window.open(FakeData.baseURL+"/game-video/1111", 'Game Streaming', 'menubar=no,location=no,resizable=no');

    // STEP 4: append the container <div> (that has props.children appended to it) to the body of the new window
    this.externalWindow.document.body.appendChild(this.containerEl);
    //copyStyles(document, this.externalWindow.document);
  }

  componentWillUnmount() {
    // STEP 5: This will fire when this.state.showWindowPortal in the parent component becomes false
    // So we tidy up by closing the window
    this.externalWindow.close();
    FakeData.setData("currentGameScreen", false);
  }
}

export class GMCCoreTeam extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      isModalReverseOpen: false,
      selectedPlayer: {},
      playerTo: {}
    }

    this.saveSub = this.saveSub.bind(this)
    this.saveSubReverse = this.saveSubReverse.bind(this)
  }

  saveSub() {
    const dataTo = {
      game: this.props.game,
      team: this.props.team,
      oldPlayer: this.state.selectedPlayer,
      newPlayer: this.state.playerTo,
      endTime: (this.props.game.duration * 60),
      currentTime: this.props.currentTime
    }

    const _that = this
    FakeData.post('/substitutePlayer.php?auth0', dataTo, {
      success: ((data) => {
        _that.props.onSub(_that.state.selectedPlayer, _that.state.playerTo, _that.props.team.id)
        _that.props.onPostComment(data)
        _that.setState({
          isModalOpen: false,
          playerTo: {}
        })
      }),
      error: ((err) => {

      })
    })
  }

  saveSubReverse() {
    const dataTo = {
      game: this.props.game,
      team: this.props.team,
      newPlayer: this.state.selectedPlayer,
      oldPlayer: this.state.playerTo,
      endTime: (this.props.game.duration * 60),
      currentTime: this.props.currentTime
    }

    const _that = this
    FakeData.post('/substitutePlayer.php?auth0', dataTo, {
      success: ((data) => {
        _that.props.onSub(_that.state.playerTo, _that.state.selectedPlayer, _that.props.team.id)
        _that.props.onPostComment(data)
        _that.setState({
          isModalReverseOpen: false,
          playerTo: {}
        })
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    const items = this.props.team.lineup
    const subs = this.props.team.subs
    return (
      <div className="gmc-core-team">
        <div className="gmc_team_one_logo"><img src={this.props.team.image} />Players</div>
        <div className="gmc_teams_players">
          <ul>
            {items.length > 0 &&
              items.map((item, i) =>
                <li key={i} className="players">
                  <a className="game-player" onClick={() => {
                    if ((!this.props.game.isPlaying)) {
                      FakeData.alert("The game is not in motion yet, cannot perform this action!");
                      return;
                    }
                    this.props.onPlayerSelect(item, this.props.team)
                  }}>{item.name}({item.number}) - {item.position}</a>
                  <img src=".././images/substitution_icon.svg" className="change_player_status" onClick={() => {
                    if ((!this.props.game.isPlaying)) {
                      FakeData.alert("The game is not in motion yet, cannot perform this action!");
                      return;
                    }
                    this.setState({
                      isModalOpen: true,
                      selectedPlayer: item
                    })
                  }} />
                </li>
              )
            }

            {items.length <= 0 &&
              <h4 style={{ fontSize: "12px", color: "#cccccc", textAlign: "center", padding: "20px" }}>No Players Added</h4>
            }
          </ul>
          <Modal isOpen={this.state.isModalOpen} onClose={() => this.setState({
            isModalOpen: false
          })}>
            <div className="substitution">
              <div className="players">
                <div className="player">
                  <img src={this.state.selectedPlayer.image} />
                  <span>{this.state.selectedPlayer.name}</span>
                </div>
              </div>
              <div className="gmc_teams_players players-list">
                {(this.state.playerTo.id == null) &&
                  <h1>Substitute</h1>
                }
                <ul>
                  {(subs.length > 0 && (this.state.playerTo.id == null)) &&
                    subs.map((item, i) => {
                      if (item.status == "lineup-sub") {
                        return null
                      } else {
                        return (
                          <li key={i} className="players" onClick={() => this.setState({
                            playerTo: item
                          })}>
                            <a className="game-player">{item.name} ({item.position} - J{item.number})</a>
                            <img src=".././images/substitution_icon.svg" className="change_player_status" />
                          </li>
                        )
                      }
                    })
                  }

                  {(subs.length <= 0 && (this.state.playerTo.id == null)) &&
                    <h4 style={{ fontSize: "12px", color: "#cccccc", textAlign: "center", padding: "20px" }}>No Players Added</h4>
                  }
                </ul>
                {this.state.playerTo.id != null &&
                  <div className="player">
                    <img src={this.state.playerTo.image} />
                    <span>{this.state.playerTo.name}</span>
                  </div>
                }
              </div>
              {this.state.playerTo.id != null &&
                <div className="sub-act">
                  <button className="button change-subs" onClick={() => this.setState({
                    playerTo: {}
                  })}>Change Player</button>
                  <button className="button save-subs" onClick={this.saveSub}>Save</button>
                </div>
              }
            </div>
          </Modal>

          <Modal isOpen={this.state.isModalReverseOpen} onClose={() => this.setState({
            isModalReverseOpen: false
          })}>
            <div className="substitution">
              <div className="players">
                <div className="player">
                  <img src={this.state.selectedPlayer.image} />
                  <span>{this.state.selectedPlayer.name}</span>
                </div>
              </div>
              <div className="gmc_teams_players players-list">
                {(this.state.playerTo.id == null) &&
                  <h1>Substitute</h1>
                }
                <ul>
                  {(items.length > 0 && (this.state.playerTo.id == null)) &&
                    items.map((item, i) => {
                      if (item.status == "sub-lineup") {
                        return null
                      } else {
                        return (
                          <li key={i} className="players" onClick={() => this.setState({
                            playerTo: item
                          })}>
                            <a className="game-player">{item.name} ({item.position} - J{item.number})</a>
                            <img src=".././images/substitution_icon.svg" className="change_player_status" />
                          </li>
                        )
                      }
                    })
                  }

                  {(items.length <= 0 && (this.state.playerTo.id == null)) &&
                    <h4 style={{ fontSize: "12px", color: "#cccccc", textAlign: "center", padding: "20px" }}>No Players Added</h4>
                  }
                </ul>
                {this.state.playerTo.id != null &&
                  <div className="player">
                    <img src={this.state.playerTo.image} />
                    <span>{this.state.playerTo.name}</span>
                  </div>
                }
              </div>
              {this.state.playerTo.id != null &&
                <div className="sub-act">
                  <button className="button change-subs" onClick={() => this.setState({
                    playerTo: {}
                  })}>Change Player</button>
                  <button className="button save-subs" onClick={this.saveSubReverse}>Save</button>
                </div>
              }
            </div>
          </Modal>


        </div>
        <div className="gmc_team_subs"><img src=".././images/substitution_icon.svg" />Substitutes</div>
        <div className="gmc_teams_players">
          <ul>
            {subs.length > 0 &&
              subs.map((item, i) =>
                <li key={i} className="players">
                  <a className="game-player">{item.name}({item.number}) - {item.position}</a>
                  <img src=".././images/substitution_icon.svg" className="change_player_status" onClick={() => {
                    if ((!this.props.game.isPlaying)) {
                      FakeData.alert("The game is not in motion yet, cannot perform this action!");
                      return;
                    }
                    this.setState({
                      isModalReverseOpen: true,
                      selectedPlayer: item
                    })
                  }} />
                </li>
              )
            }

            {subs.length <= 0 &&
              <h4 style={{ fontSize: "12px", color: "#cccccc", textAlign: "center", padding: "20px" }}>No Players Added</h4>
            }
          </ul>
        </div>
      </div>
    );
  }
}

export class GMCCoreFeed extends React.Component {
  constructor(props) {
    super(props)
  }

  fancyTimeFormat(time) {
    return ((Math.floor(time / 60) < 10) ? "0" + Math.floor(time / 60) : Math.floor(time / 60)) + ":" + (time % 60 ? ((time % 60 < 10) ? "0" + Math.floor(time % 60) : Math.floor(time % 60)) : '00');
  }

  render() {
    const currentTime = this.fancyTimeFormat(this.props.currentTime)
    const extraTime = this.fancyTimeFormat(this.props.extraTime)
    return (
      <div className="gmc-core-feed">
        <div className="gmc-core-feed-header">
          <h1>Have Your Say</h1>
          <span>Extratime : {extraTime}</span>
          <span>{currentTime}</span>
        </div>
        <GMCCoreFeedForm removeTagged={this.props.removeTagged} onUpdatePossesion={this.props.onUpdatePossesion} onCommentChange={this.props.onCommentChange} value={this.props.value} onTeamSelect={this.props.onTeamSelect} onTeamTagSelect={this.props.onTeamTagSelect} onPlayerTagSelect={this.props.onPlayerTagSelect} selectionState={this.props.selectionState} teamTags={this.props.teamTags} playerTags={this.props.playerTags} game={this.props.game} onPost={this.props.onPost} />
        <GMCCoreFeedComments onDelete={this.props.onDelete} onSave={this.props.onSave} onAgree={this.props.onAgree} onAddQuery={this.props.onAddQuery} Comments={this.props.Comments} game={this.props.game} />
      </div>
    );
  }
}

export class GMCCoreFeedForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      teamTags: this.props.teamTags,
      comment: "",
      player: {},
      players: [],
      teamOne: 0,
      teamTwo: 0,
      isGoal: false,
      isModalOpen: false,
      placeholder: "Write something..."
    }

    this.onCommentChange = this.onCommentChange.bind(this)
  }

  onCommentChange(e) {
    const val = e.replace(/\[.*?\]\s?/g, '');
    //console.log(val);
    this.setState({
      comment: val
    });
  }

  setPossesion(team, e) {
    if (team == "teamOne") {
      const pos = 100 - e.target.value
      this.setState({
        teamOne: e.target.value,
        teamTwo: pos
      });
    } else {
      const pos = 100 - e.target.value
      this.setState({
        teamTwo: e.target.value,
        teamOne: pos
      });
    }
  }

  updatePossesion() {
    if ((this.state.teamOne == 0) && (this.state.teamTwo == 0)) {
      return
    }
    this.props.onUpdatePossesion(this.state.teamOne, this.state.teamTwo)
  }

  render() {
    const teamTags = this.state.teamTags
    const playerTags = this.props.playerTags
    const html = (this.state.comment === "") ? this.state.placeholder : this.state.comment;
    return (
      <div className="gmc-core-feed-form">
        <div className={(!this.props.game.isAdmin) ? "gmc-write-comment disabled" : "gmc-write-comment"}>
          {(this.props.value !== "" && this.props.game.isAdmin) &&
            <span className="gmc-write-comment-tag">{this.props.value}<i className="material-icons" onClick={this.props.removeTagged}>close</i></span>
          }
          <div ref={(ref) => this.inputBox = (ref !== null) ? ref : this.inputBox} data-placeholder={this.state.placeholder} className="gmc-write-comment-field" contentEditable={this.props.game.isAdmin} onFocus={() => {
            this.setState({ placeholder: "" });
          }} tabIndex={0} onBlur={() => {
            this.setState({ placeholder: (this.state.comment === "" && this.props.value === "") ? "Write something..." : "" });
          }} onInput={(e) => {
            this.setState({ comment: e.target.innerHTML });
          }}></div>
        </div>
        <textarea disabled={(!this.props.game.isAdmin) ? true : false} value={this.props.value + ' ' + this.state.comment} className="write_gmc_comment textarea" onChange={(e) => this.onCommentChange(e.target.value)} placeholder="Write something..."></textarea>
        {this.state.isGoal &&
          <div className="add-assist">
            <span>Add Assist?</span>
            <button style={{ background: "#4EA3C9", color: "#fff", fontSize: "10px" }} onClick={() => { this.setState({ isModalOpen: true }) }}>Add</button>
            <button style={{ background: "#F46", color: "#fff", fontSize: "10px" }} onClick={() => {
              this.setState({
                isGoal: false
              });
              this.props.onPlayerTagSelect("Goal", {})
            }}>Cancel</button>
          </div>
        }
        <div className="gmc-tags">
          {
            playerTags.map((tag, i) =>
              <div key={i} className="gmc-tag" onClick={() => {
                if ((!this.props.game.isPlaying)) {
                  FakeData.alert("The game is not in motion yet, cannot perform this action!");
                  return;
                }
                if (tag == "Goal") {
                  this.setState({
                    isGoal: true
                  });
                } else {
                  this.props.onPlayerTagSelect(tag, {})
                }
              }}>{tag}</div>
            )
          }
        </div>
        <div className="gmc-tags" style={{ borderTop: "0.3px dashed #ccc", margin: "10px 0px", borderBottom: "0.3px dashed #ccc", paddingBottom: "10px" }}>
          {
            teamTags.map((tag, i) =>
              <div key={i} className="gmc-tag" onClick={() => {
                if ((!this.props.game.isPlaying)) {
                  FakeData.alert("The game is not in motion yet, cannot perform this action!");
                  return;
                }
                this.props.onTeamTagSelect(tag)
              }}>{tag}</div>
            )
          }

          <div className="gmc-tag tag_team" onClick={() => this.props.onTeamSelect(this.props.game.teamOne)}>{this.props.game.teamOne.name}</div>
          <div className="gmc-tag tag_team" onClick={() => this.props.onTeamSelect(this.props.game.teamTwo)}>{this.props.game.teamTwo.name}</div>
        </div>
        <div className="gmc-position-form">
          <label>{this.props.game.teamOne.name}<br /><input type="number" max="100" min="0" disabled={!this.props.game.isPlaying} value={this.state.teamOne} onChange={(e) => this.setPossesion("teamOne", e)} /></label>
          <label>{this.props.game.teamTwo.name}<br /><input type="number" max="100" min="0" disabled={!this.props.game.isPlaying} value={this.state.teamTwo} onChange={(e) => this.setPossesion("teamTwo", e)} /></label>
          <button className="button" onClick={() => this.updatePossesion()}>Update</button>
        </div>
        <div className="gmc_comment_button_holder">
          <div className="gmc_buttons gmc_submit" onClick={() => this.props.onPost(this.state.comment, () => {
            this.setState({
              comment: "",
              placeholder: "Write something...",
              player: {},
              players: []
            })
            this.inputBox.innerHTML = ""
          })}>Submit</div>
        </div>
        <Modal isOpen={this.state.isModalOpen} onClose={() => {
          this.setState({ isModalOpen: false, isGoal: false })
          this.props.onPlayerTagSelect("Goal", {})
        }
        }>
          <div className="add-place">
            <h1>Select Player</h1>
            {(this.state.players.length == 0) &&
              <div className="select-assist">
                <button onClick={() => this.setState({ players: this.props.game.teamOne.lineup })}>{this.props.game.teamOne.name}</button>
                <span>or</span>
                <button onClick={() => this.setState({ players: this.props.game.teamTwo.lineup })}>{this.props.game.teamTwo.name}</button>
              </div>
            }

            {(this.state.players.length > 0) &&
              <div className="select-list-assist">
                {
                  this.state.players.map((item, i) =>
                    <div key={i} onClick={() => this.setState({ player: item })} className={(this.state.player.id == item.id) ? "active" : ""}>
                      {item.name}
                    </div>
                  )
                }
              </div>
            }
            {this.state.player.id &&
              <button onClick={() => {
                this.setState({ isModalOpen: false, isGoal: false })
                this.props.onPlayerTagSelect("Goal", this.state.player)
              }}>Add</button>
            }
          </div>
        </Modal>
      </div>
    );
  }
}

export class GMCCoreFeedComments extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      comments: this.props.Comments
    }
  }

  render() {
    const items = this.state.comments
    return (
      <div className="gmc-core-feed-comments">
        <h1>Live Commentary</h1>
        <div className="gmc-comment-list">
          {
            items.map((item, i) =>
              <GMCCoreFeedComment key={i} onDelete={this.props.onDelete} onSave={this.props.onSave} onAgree={this.props.onAgree} onAddQuery={this.props.onAddQuery} user={this.props.user} game={this.props.game} comment={item} key={item.id} />
            )
          }
        </div>
      </div>
    );
  }
}

export class GMCCoreFeedComment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isEditting: false,
      comment: "",
      editComment: this.props.comment.content
    }

    this.onTextChange = this.onTextChange.bind(this)
    this.sendComment = this.sendComment.bind(this)
    this.agreeTo = this.agreeTo.bind(this)
    this.onEditChange = this.onEditChange.bind(this)
    this.saveComment = this.saveComment.bind(this)
    this.deleteComment = this.deleteComment.bind(this)
  }

  onTextChange(e) {
    this.setState({
      comment: e.target.value
    });
  }

  onEditChange(e) {
    this.setState({
      editComment: e.target.value
    });
  }

  sendComment() {
    if (this.state.comment == "") {
      return
    }
    const dataTo = {
      comment: this.state.comment,
      gmcId: this.props.comment.id,
      team: (this.props.game.isAdmin) ? { id: 0 } : this.props.game.yourTeam
    }

    const _that = this

    FakeData.post('/createGMCQuery.php?auth0', dataTo, {
      success: ((data) => {
        _that.setState({
          comment: ""
        })

        _that.props.onAddQuery(data, _that.props.comment.id)
      }),
      error: ((err) => {

      })
    })
  }

  agreeTo() {
    if (this.props.game.isAdmin) {
      return
    }

    const dataTo = {
      gmcId: this.props.comment.id,
      field: (this.props.game.yourTeam.id == this.props.game.teamOne.id) ? "teamOneConfirm" : "teamTwoConfirm"
    }

    const _that = this

    FakeData.post('/GMCAgree.php?auth0', dataTo, {
      success: ((data) => {
        _that.props.onAgree(data.status, dataTo.field, _that.props.comment.id)
      }),
      error: ((err) => {

      })
    })
  }

  deleteComment() {
    if (!this.props.game.isAdmin) {
      return
    }

    const dataTo = {
      gmcId: this.props.comment.id
    }

    const _that = this

    FakeData.post('/deleteGMCComment.php?auth0', dataTo, {
      success: ((data) => {
        _that.props.onDelete(data.status, _that.props.comment.id)
      }),
      error: ((err) => {

      })
    })
  }

  saveComment() {
    if (!this.props.game.isAdmin) {
      return
    }

    const dataTo = {
      gmcId: this.props.comment.id,
      content: this.state.editComment
    }

    const _that = this


    FakeData.post('/saveGMCComment.php?auth0', dataTo, {
      success: ((data) => {
        _that.props.onSave(_that.state.editComment, _that.props.comment.id)
        _that.setState({
          isEditting: false
        });
      }),
      error: ((err) => {

      })
    })
  }

  render() {
    const item = this.props.comment
    const items = item.Queries
    return (
      <div className="gmc-core-feed-comment">
        <span className="gmc-core-feed-comment-number">{item.minute}</span>
        <div className="gmc-core-feed-comment-content">
          {!this.state.isEditting &&
            <div className="text">{item.content}</div>
          }
          {this.state.isEditting &&
            <textarea className="text-edit" onChange={(e) => this.onEditChange(e)} value={this.state.editComment}></textarea>
          }

          {this.state.isEditting &&
            <button className="button" onClick={this.saveComment}>Save</button>
          }
          <div className="team-actions">
            <div className={(item.isTeamOneAgreed) ? "gmc_verified_team" : "gmc_unverified_team"}>{this.props.game.teamOne.name}</div>
            <div className={(item.isTeamTwoAgreed) ? "gmc_verified_team" : "gmc_unverified_team"}>{this.props.game.teamTwo.name}</div>
            <div className="gmc_unverified_team team_disagree" onClick={() => this.setState({
              isDisagreeing: (this.state.isDisagreeing) ? false : true
            })}>Disagree</div>
            <div className="gmc_verified_team team_agree" onClick={this.agreeTo}>Agree</div>
          </div>
          {this.state.isDisagreeing &&
            <div className="team-comments">
              {
                items.map((x, i) =>
                  <div className={(i % 2 == 0) ? "team-comment" : "team-comment odd"} key={i}>
                    <span>{(x.team.id == 0) ? "Admin" : x.team.name}</span>
                    <span>{x.comment}</span>
                  </div>
                )
              }
              <div className="team-input">
                <input value={this.state.comment} placeholder="Write your reasons here..." onChange={(e) => this.onTextChange(e)} />
                <button onClick={this.sendComment}>Submit</button>
              </div>
            </div>
          }
        </div>
        {this.props.game.isAdmin &&
          <div className="gmc-core-feed-comment-action gmc_live_icons">
            <div className="gmc_edit_comment" onClick={() => this.setState({
              isEditting: (this.state.isEditting) ? false : true
            })}></div>
            <div className="gmc_delete_comment" onClick={this.deleteComment}></div>
          </div>
        }
      </div>
    );
  }
}

export class VerifyPlayersForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      activeTab: 0,
      teamOne: this.props.game.teamOne,
      teamTwo: this.props.game.teamTwo,
    }
    this.addLineUpPlayerOne = this.addLineUpPlayerOne.bind(this)
    this.addSubPlayerOne = this.addSubPlayerOne.bind(this)
    this.removeLineupPlayerOne = this.removeLineupPlayerOne.bind(this)
    this.removeSubPlayerOne = this.removeSubPlayerOne.bind(this)

    this.addLineUpPlayerTwo = this.addLineUpPlayerTwo.bind(this)
    this.addSubPlayerTwo = this.addSubPlayerTwo.bind(this)
    this.removeLineupPlayerTwo = this.removeLineupPlayerTwo.bind(this)
    this.removeSubPlayerTwo = this.removeSubPlayerTwo.bind(this)
  }

  componentWillMount() {
    if (this.props.game.sport == "Soccer") {
      this.setState({
        maxLineup: 11,
        maxSubs: 5
      })
    }
  }

  addLineUpPlayerOne(player) {
    if ((this.props.game.teamOne.lineup.indexOf(player) == -1) && (this.props.game.teamOne.lineup.length < this.state.maxLineup)) {
      this.props.game.teamOne.lineup.push(player)
      this.setState({
        teamOne: this.props.game.teamOne
      });
    }

    this.props.onLineupChangeOne(this.props.game.teamOne)
  }

  addSubPlayerOne(player) {
    if ((this.props.game.teamOne.subs.indexOf(player) == -1) && (this.props.game.teamOne.subs.length < this.state.maxSubs)) {
      this.props.game.teamOne.subs.push(player)
      this.setState({
        teamOne: this.props.game.teamOne
      });
    }

    this.props.onLineupChangeOne(this.props.game.teamOne)
    this.setTab = this.setTab.bind(this)
  }

  removeLineupPlayerOne(player) {
    if (this.props.game.teamOne.lineup.indexOf(player) != -1) {
      const index = this.props.game.teamOne.lineup.indexOf(player)
      this.props.game.teamOne.lineup.splice(index, 1)
      this.setState({
        teamOne: this.props.game.teamOne
      });
    }

    this.props.onLineupChangeOne(this.props.game.teamOne)
  }

  removeSubPlayerOne(player) {
    if (this.props.game.teamOne.subs.indexOf(player) != -1) {
      const index = this.props.game.teamOne.subs.indexOf(player)
      this.props.game.teamOne.subs.splice(index, 1)
      this.setState({
        team: this.props.game.teamOne
      });
    }

    this.props.onLineupChangeOne(this.props.game.teamOne)
  }

  addLineUpPlayerTwo(player) {
    if ((this.props.game.teamTwo.lineup.indexOf(player) == -1) && (this.props.game.teamTwo.lineup.length < this.state.maxLineup)) {
      this.props.game.teamTwo.lineup.push(player)
      this.setState({
        teamTwo: this.props.game.teamTwo
      });
    }

    this.props.onLineupChangeTwo(this.props.game.teamTwo)
  }

  addSubPlayerTwo(player) {
    if ((this.props.game.teamTwo.subs.indexOf(player) == -1) && (this.props.game.teamTwo.subs.length < this.state.maxSubs)) {
      this.props.game.teamTwo.subs.push(player)
      this.setState({
        teamTwo: this.props.game.teamTwo
      });
    }

    this.props.onLineupChangeTwo(this.props.game.teamTwo)
    this.setTab = this.setTab.bind(this)
  }

  removeLineupPlayerTwo(player) {
    if (this.props.game.teamTwo.lineup.indexOf(player) != -1) {
      const index = this.props.game.teamTwo.lineup.indexOf(player)
      this.props.game.teamTwo.lineup.splice(index, 1)
      this.setState({
        teamTwo: this.props.game.teamTwo
      });
    }

    this.props.onLineupChangeTwo(this.props.game.teamTwo)
  }

  removeSubPlayerTwo(player) {
    if (this.props.game.teamTwo.subs.indexOf(player) != -1) {
      const index = this.props.game.teamTwo.subs.indexOf(player)
      this.props.game.teamTwo.subs.splice(index, 1)
      this.setState({
        team: this.props.game.teamTwo
      });
    }

    this.props.onLineupChangeTwo(this.props.game.teamTwo)
  }

  setTab(int) {
    this.setState(prevState => ({
      activeTab: int
    }));
  }

  onSave(team, players, lineup, subs, cb) {
    const isTeamOne = (this.props.game.teamOne.squadId === team.squadId && this.props.game.teamOne.id === team.id) ? true : false;
    if (isTeamOne) {
      const _team = this.props.game.teamOne;
      _team.players = players;
      _team.lineup = lineup;
      _team.subs = subs;
      this.props.onLineupChangeOne(_team)
      cb.call(this)
    } else {
      const _team = this.props.game.teamTwo;
      _team.players = players;
      _team.lineup = lineup;
      _team.subs = subs;
      this.props.onLineupChangeTwo(_team)
      cb.call(this)
    }
  }

  render() {
    const classOne = 'add-player-view home'
    const classTwo = 'add-player-view away'
    const { lineup, subs } = LineupLimit[this.props.game.sport.toLowerCase()]
    if (!this.same) {
      return (
        <PitchVerifyConfig onSaveLineUp={this.props.onSaveLineUp} maxLineup={lineup} maxSubs={subs} onSave={this.onSave.bind(this)} game={this.props.game} />
      )
    }
    return (
      <div className="add-players-form">
        <div className="add-player-segment">
          <div className={(this.state.activeTab == 0) ? 'item active' : 'item'} onClick={() => this.setTab(0)}>{this.props.game.teamOne.name}</div>
          <div className={(this.state.activeTab == 1) ? 'item active' : 'item'} onClick={() => this.setTab(1)}>{this.props.game.teamTwo.name}</div>
        </div>
        {(this.state.activeTab == 0)
          ? <VerifyPlayerView game={this.props.game} onPlayerAdd={this.props.onNewPlayerAddedTeamOne} maxSubs={this.state.maxSubs} maxLineup={this.state.maxLineup} onRemoveLineUp={this.removeLineupPlayerOne} onRemoveSub={this.removeSubPlayerOne} onAddLineUp={this.addLineUpPlayerOne} onAddSub={this.addSubPlayerOne} team={this.props.game.teamOne} otherTeam={this.props.game.teamTwo} className={classOne} /> :
          <VerifyPlayerView game={this.props.game} onPlayerAdd={this.props.onNewPlayerAddedTeamTwo} maxSubs={this.state.maxSubs} maxLineup={this.state.maxLineup} team={this.props.game.teamTwo} onRemoveLineUp={this.removeLineupPlayerTwo} onRemoveSub={this.removeSubPlayerTwo} onAddLineUp={this.addLineUpPlayerTwo} onAddSub={this.addSubPlayerTwo} otherTeam={this.props.game.teamOne} className={classTwo} />
        }

        <button className="button" onClick={() => this.props.onSaveLineUp()}>Save</button>
      </div>
    );
  }
}

export class PitchVerifyConfig extends Component {
  state = {
    activeTab: 0,
    isEditting: false,
    editTeam: null,
    tokenOne: Date.now() + "one",
    tokenTwo: Date.now() + "two",
    openToken: Date.now()
  }

  setTab = (int) => {
    this.setState(prevState => ({
      activeTab: int
    }));
  }

  onSave = (players, lineup, subs) => {
    const _that = this
    const { editTeam } = this.state
    const dataTo = {
      gameId: this.props.game.id,
      teamId: editTeam.id,
      squadId: editTeam.squadId,
      adminId: this.props.game.matchAdmin.id,
      lineup: lineup,
      subs: subs,
      starttime: 0,
      endTime: this.props.game.duration
    }

    FakeData.post("/saveGamePlayers.php?auth0", dataTo, {
      success: ((data) => {
        console.log(data)
        _that.props.onSave(this.state.editTeam, players, lineup, subs, () => { })
        _that.setState({
          isEditting: false,
          editTeam: null,
          tokenOne: Date.now() + "one",
          tokenTwo: Date.now() + "two",
          openToken: Date.now()
        });
      }),
      error: ((err) => {
        FakeData.alert("Couldn't reach server, please check your connection and try again!")
        _that.setState({
          isEditting: false,
          editTeam: null,
          tokenOne: Date.now() + "one",
          tokenTwo: Date.now() + "two",
          openToken: Date.now()
        });
      })
    }, true, "", (e) => { })
  }

  render() {
    const { tokenOne, tokenTwo, openToken, editTeam } = this.state
    return (
      <div className="pitch-config">
        <div className="pitch-config-header">
          <div className={(this.state.activeTab == 0) ? 'active' : ''} onClick={() => this.setTab(0)}>{this.props.game.teamOne.name}</div>
          <div className={(this.state.activeTab == 1) ? 'active' : ''} onClick={() => this.setTab(1)}>{this.props.game.teamTwo.name}</div>
        </div>
        <div className="pitch-config-body" style={{ height: "600px", width: "100%" }}>
          {(this.state.activeTab == 0) &&
            <div style={{ height: "600px", width: "100%" }}>
              <SoccerPitch key={tokenOne} maxLineup={this.props.maxLineup} isGMC={true} sport={this.props.game.sport} readOnly={true} team={this.props.game.teamOne} players={this.props.game.teamOne.players} maxSubs={this.props.maxSubs} lineup={this.props.game.teamOne.lineup} subs={this.props.game.teamOne.subs} />
              <div className="pitch-config-body-edit" onClick={() => {
                this.setState((state, props) => ({
                  isEditting: true,
                  editTeam: this.props.game.teamOne,
                  openToken: Date.now(),
                  tokenOne: Date.now() + "one",
                  tokenTwo: Date.now() + "two"
                }));
              }}>
                <i className="material-icons">edit</i>
              </div>
            </div>
          }
          {(this.state.activeTab == 1) &&
            <div style={{ height: "600px", width: "100%" }}>
              <SoccerPitch key={tokenTwo} maxLineup={this.props.maxLineup} isGMC={true} sport={this.props.game.sport} readOnly={true} team={this.props.game.teamTwo} players={this.props.game.teamTwo.players} maxSubs={this.props.maxSubs} lineup={this.props.game.teamTwo.lineup} subs={this.props.game.teamTwo.subs} />
              <div className="pitch-config-body-edit" onClick={() => {
                this.setState((state, props) => ({
                  isEditting: true,
                  editTeam: this.props.game.teamTwo,
                  openToken: Date.now(),
                  tokenOne: Date.now() + "one",
                  tokenTwo: Date.now() + "two"
                }));
              }}>
                <i className="material-icons">edit</i>
              </div>
            </div>
          }
        </div>
        <div className="pitch-config-footer">
          <div className={(this.state.activeTab == 0) ? 'active' : ''} onClick={() => this.setTab(0)} />
          <div className={(this.state.activeTab == 1) ? 'active' : ''} onClick={() => this.setTab(1)} />
        </div>
        {this.state.isEditting &&
          <Modal classes={"transparent-bg"} isTransparent={true} isOpen={this.state.isEditting} onClose={() => {
            this.setState((state, props) => ({
              isEditting: false,
              editTeam: null,
              openToken: Date.now(),
              tokenOne: Date.now() + "one",
              tokenTwo: Date.now() + "two"
            }));
          }}>
            <div style={{ width: "950px", height: "500px" }}>
              <SoccerPitch onSave={this.onSave.bind(this)} key={openToken} maxLineup={this.props.maxLineup} isGMC={true} sport={this.props.game.sport} team={editTeam} players={editTeam.players} maxSubs={this.props.maxSubs} lineup={editTeam.lineup} subs={editTeam.subs} />
            </div>
          </Modal>
        }
        <button className="button" onClick={() => {
          this.props.onSaveLineUp(this.props.game.teamOne, this.props.game.teamTwo)
        }}>Save</button>
      </div>
    );
  }
}

export class VerifyPlayerView extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div className={this.props.className}>
        <AddPlayToLineUpView onPlayerAdd={this.props.onPlayerAdd} onRemoveLineUp={this.props.onRemoveLineUp} onRemoveSub={this.props.onRemoveSub} onAddLineUp={this.props.onAddLineUp} onAddSub={this.props.onAddSub} team={this.props.team} />
        <AddPlayLineUpView maxSubs={this.props.maxSubs} maxLineup={this.props.maxLineup} onRemoveLineUp={this.props.onRemoveLineUp} onRemoveSub={this.props.onRemoveSub} team={this.props.team} />
      </div>
    );
  }
}

export class Stand extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isViewing: false,
      default: "Group A",
      prev: 0,
      next: 1,
      isPlayOffsView: false,
      popped: ""
    }
  }

  setTable(index) {
    this.setState({
      default: this.props.stand.groups[index].name
    });
  }

  openPop() {
    this.setState({
      popped: this.state.default
    });
  }

  closePop() {
    this.setState({
      popped: ""
    });

    if(this.props.onRefreshData){
      this.props.onRefreshData()
    }
  }

  render() {
    this.props.stand.groups.forEach((item) => {
      item.teams.sort(function (a, b) {
        return b.name - a.name
      })
    })

    this.props.stand.groups.forEach((item) => {
      item.teams.sort(function (a, b) {
        if (b.pts == a.pts) {
          return b.gd - a.gd
        }
        return b.pts - a.pts
      })
    })

    return (
      <div className={"stand " + this.props.class}>
        <div className="stand-titles">
          <span>{this.props.stand.name}</span>
          <div className="stand-actions">
            {((this.props.stand.type == "group_knockout") || (this.props.stand.type == "league")) &&
              <span className={(this.state.isViewing) ? "active" : ""} onClick={() => {
                this.setState({
                  isViewing: (this.state.isViewing) ? false : true,
                  isPlayOffsView: false
                })
              }}>Groups</span>
            }
            {((this.props.stand.type == "group_knockout") || (this.props.stand.type == "knockout")) &&
              <span className={(this.state.isPlayOffsView) ? "active" : ""} onClick={() => {
                this.setState({
                  isPlayOffsView: (this.state.isPlayOffsView) ? false : true,
                  isViewing: false
                })
              }}>Play-offs</span>
            }
            <span><Link  to={"/league/" + this.props.stand.id}>Manage</Link></span>
          </div>
        </div>
        {(this.state.isViewing && this.props.stand.groups.length == 1) &&
          <div className="stand-tables">
            <div className="stand-controls">
              <div className="stand-control-holder">
                {
                  this.props.stand.groups.map((item, i) =>
                    <div key={i} className={(this.state.default == item.name) ? "stand-control active" : "stand-control"} onClick={() => this.setTable(i)}>Log</div>
                  )
                }
              </div>
              <div className="stand-manage" onClick={() => this.openPop()}>Manage Games</div>
            </div>
            <GroupStand user={this.props.user} default={this.state.default} popped={this.state.popped} onClose={() => this.closePop()} group={this.props.stand.groups[0]} />
          </div>
        }

        {(this.state.isViewing && this.props.stand.groups.length > 1) &&
          <div className="stand-tables-group">
            {(this.props.stand.type == "group_knockout") &&
              <div className="stand-controls">
                <div className="stand-control-holder">
                  {
                    this.props.stand.groups.map((item, i) =>
                      <div key={i} className={(this.state.default == item.name) ? "stand-control active" : "stand-control"} onClick={() => this.setTable(i)}>{item.name}</div>
                    )
                  }
                </div>
                <div className="stand-manage" onClick={() => this.openPop()}>Manage Games</div>
              </div>
            }
            {
              this.props.stand.groups.map((group, i) =>
                <GroupGames key={i} default={this.state.default} group={group} />
              )
            }
            {
              this.props.stand.groups.map((group, x) =>
                <GroupStand user={this.props.user} key={x} default={this.state.default} popped={this.state.popped} onClose={() => this.closePop()} group={group} />
              )
            }
          </div>
        }

        {this.state.isPlayOffsView &&
          <PlayOffView playOffs={this.props.stand.playOffs} teams={this.props.stand.teams.current} isAdmin="true" />
        }
      </div>
    );
  }
}

export class GroupStand extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const group = this.props.group
    const isOpen = ((this.props.popped == group.name) ? true : false)
    return (
      <div className={(this.props.default == group.name) ? "stand-table active" : "stand-table"} style={{ display: ((this.props.default != group.name) ? "none" : "") }}>
        <div className="stand-table-row">
          <span><strong>No.1</strong></span>
          <span className="name"><strong>Team</strong></span>
          <span><strong>GP</strong></span>
          <span><strong>W</strong></span>
          <span><strong>D</strong></span>
          <span><strong>L</strong></span>
          <span><strong>GF</strong></span>
          <span><strong>GA</strong></span>
          <span><strong>GD</strong></span>
          <span><strong>PTS</strong></span>
        </div>
        {
          group.teams.map((item, i) =>
            <div key={i} className="stand-table-row">
              <span>{i + 1}</span>
              <span className="name">{item.name}</span>
              <span>{item.gp}</span>
              <span>{item.w}</span>
              <span>{item.d}</span>
              <span>{item.l}</span>
              <span>{item.gf}</span>
              <span>{item.ga}</span>
              <span>{item.gd}</span>
              <span>{item.pts}</span>
            </div>
          )
        }
        {!this.props.fe &&
          <SetTournGameModal user={this.props.user} games={group.games} group={group} isOpen={isOpen} onClose={() => this.props.onClose()} />
        }
      </div>
    );
  }
}

export class GroupGames extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const upcomingGames = this.props.group.upcomingGames
    if (this.props.default != this.props.group.name) {
      return null;
    }

    if (upcomingGames.length == 0) {
      return null;
    }

    return (
      <div className="group-games">
        <div className="group-game head">
          <span>Date</span>
          <span>Venue</span>
          <span>Team 1</span>
          <span>Score</span>
          <span>Team 2</span>
        </div>
        {
          upcomingGames.map((item, i) =>
            <div key={i} className="group-game">
              <span>{item.matchDate}</span>
              <span>{item.matchPlace}</span>
              <span className="img"><img src={item.teamOne.image} /> {item.teamOne.name}</span>
              <span>{(item.isFinished) ? item.res.teamOneGoals + " - " + item.res.teamTwoGoals : "vs"}</span>
              <span className="img">{item.teamTwo.name} <img src={item.teamTwo.image} /></span>
            </div>
          )
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GMC.js